/* eslint-disable */

import React, { Fragment, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import { connect } from "react-redux";

import { setIsPBSAuthorityRequired, updateEbsNumber } from "../../../reduxStore/actions/auth";

import { getFormattedDate, getFormattedTime } from "../../../utils/dateTimeHelper";

import { formatMedicareNo } from "../../../utils/common";

import Loader from "../../../components/loader";
import Button from "../../../components/button";
import ICInput from "../../../components/form/input";
import SearchInput from "../../../components/searchInput";
import Label from "../../../components/label";
import ICCheckbox from "../../../components/form/checkbox";
import CustomModal from "../../../components/modal";
import ICSelect from "../../../components/form/selectInput";
import {
  getDrugPBSDetailsByPBSCodeApiRoute,
  getDrugProductDetailsByIdApiRoute,
  getProductsByBrandApiRoute,
  getProductsByIngredientApiRoute
} from "../../../apiRoutes";
import MakeAPICall from "../../../apiCalls/common";
import { DrugListDialog, RestrictionListView } from "./PrescriptionComponents";
import {
  discontinuedDrugList,
  extemporaneousDrugList,
  inPersonGPDrugList,
  isotretinoinDrugList,
  outOfStockDrugError,
  S4DisabledDrugList,
  S4WarningDrugList,
  commonDrugBlockListErrors
} from "../../../constants/drugConstants";

import {
  CATEGORY_FOR_MEDICINAL_CANNABIS,
  INSTANT_HUSH_SPECIAL_DRUGS_FILLED,
  REGULATION_24_DRUG_SELECTED
} from "../../../constants/helperConstants";

import * as MIMSUtil from "../../../utils/MIMSUtil";
let prescriptionDataCache = {};

const PrescriptionForm = props => {
  const drugListRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [timeoutCount, setTimeoutCount] = useState(null);
  const [drugList, setDrugList] = useState([]);
  const [isShowDrugList, setIsShowDrugList] = useState(false);
  const [selectedDrug, setSelectedDrug] = useState({});
  const [isSelected, setIsSelected] = useState(false);
  const [isDrugManuallyInput, setIsDrugManuallyInput] = useState(false);
  const [isDrugPrefilled, setIsDrugPrefilled] = useState(false);
  const [isPoisonClassS8, setIsPoisonClassS8] = useState(false);
  const [isPoisonClassS4, setIsPoisonClassS4] = useState(false);
  const [isExtemporaneousDrug, setIsExtemporaneousDrug] = useState(false);
  const [specialDrugType, setSpecialDrugType] = useState("");
  const [drugName, setDrugName] = useState("");
  const [routeAdministration, setRouteAdministration] = useState("");
  const [formType, setFormType] = useState("");
  const [strength, setStrength] = useState("");
  const [moleculeName, setMoleculeName] = useState("");
  const [medQuantity, setMedQuantity] = useState("");
  const [medQuantityCopy, setMedQuantityCopy] = useState("");
  const [minMedQuantity, setMinMedQuantity] = useState("");
  const [medQuantitySelect, setMedQuantitySelect] = useState([]);
  const [
    medQuantitySelectWithManualInput,
    setMedQuantitySelectWithManualInput
  ] = useState([]);
  const [isManuallyEnterQty, setIsManuallyEnterQty] = useState(false);
  const [PBSCode, setPBSCode] = useState("");
  const [PBSCodeSelect, setPBSCodeSelect] = useState([]);
  const [PBSCodeForErx, setPBSCodeForErx] = useState("");
  const [PBSManufacturerCode, setPBSManufacturerCode] = useState("");
  const [RPBS, setRPBS] = useState(false);
  const [RPBSPrefilled, setRPBSPrefilled] = useState(false);
  const [PBS, setPBS] = useState(false);
  const [PBSPrefilled, setPBSPrefilled] = useState(false);
  const [blockedPBSType, setBlockedPBSType] = useState("");
  const [maxNumberOfRepeats, setMaxNumberOfRepeats] = useState(99999999); // we allow any number of repeats for Instant Switch
  const [maxQtyUnits, setMaxQtyUnits] = useState("");
  const [
    medQuantitySelectFromPBSDetails,
    setMedQuantitySelectFromPBSDetails
  ] = useState([]);
  const [maxQuantityOfMed, setMaxQuantityOfMed] = useState(99999999);
  const [
    medQuantitySelectOnMaxQtyUnits,
    setMedQuantitySelectOnMaxQtyUnits
  ] = useState([]);
  const [authorityRequiredPBS, setAuthorityRequiredPBS] = useState(false);
  const [restrictionList, setRestrictionList] = useState([]);
  const [APN, setAPN] = useState("");
  const [isAPNRequired, setIsAPNRequired] = useState(false);
  const [SAC, setSAC] = useState("");
  const [SACSelect, setSACSelect] = useState([]);
  const [emptyStomach, setEmptyStomach] = useState(false);
  const [withFood, setWithFood] = useState(false);
  const [isUnusualDose, setIsUnusualDose] = useState(false);
  const [otherPrescriptionDetails, setOtherPrescriptionDetails] = useState("");
  const [finalNumber, setFinalNumber] = useState("");
  const [acgNameInAcgs, setAcgNameInAcgs] = useState("");
  const [isDiscontinuedDrug, setIsDiscontinuedDrug] = useState(false);
  const [AIPStatus, setAIPStatus] = useState("NONE");
  const [brandName, setBrandName] = useState("");
  const [ingredient, setIngredient] = useState("");
  const [isIsotretinoinDrugList, setIsIsotretinoinDrugList] = useState(false);
  const [isInPersonGPDrugList, setIsInPersonGPDrugList] = useState(false);
  const [isOutOfStockDrug, setIsOutOfStockDrug] = useState("");

  // ERX requirement
  const patientState = props.data && props.data.patientDetails && props.data.patientDetails.address ? props.data.patientDetails.address.state : ''; // ERX Requirement
  const [controlledSubstanceReferenceFieldLabel, setControlledSubstanceReferenceFieldLabel] = useState(''); // ERX Requirement

  const [drugDetails, setDrugDetails] = useState(null);

  const [isS8DrugManuallyTicked, setIsS8DrugManuallyTicked] = useState(false); // ERX Requirement

  // ERX Requirement
  let annotationTextOptions = [
    {
      _id: '-- Select Option --',
      val: ''
    },
    {
      _id: 'for dental treatment only',
      val: 'for dental treatment only'
    },
    {
      _id: 'for midwifery use only',
      val: 'for midwifery use only'
    },
    {
      _id: 'for optometry use only',
      val: 'for optometry use only'
    },
    {
      _id: 'for podiatric treatment only',
      val: 'for podiatric treatment only'
    },
    {
      _id: 'for treatment of foot conditions only',
      val: 'for treatment of foot conditions only'
    },
    {
      _id: 'for ocular treatment only',
      val: 'for ocular treatment only'
    },
  ];

  // ERX Requirement
  let sendToPharmacyTagOptions = [
    {
      _id: 'DosingPoint',
      val: 'DosingPoint'
    },
    {
      _id: 'StagedSupply',
      val: 'StagedSupply'
    },
    {
      _id: 'RepeatOnFile',
      val: 'RepeatOnFile'
    },
  ];

  // ERX Requirement
  const [s8DrugAuthModalStatus, setS8DrugAuthModalStatus] = useState(false); // ERX Requirement

  const [showMinRepeatInterval, setShowMinRepeatInterval] = useState(false); // ERX Requirement changes

  const [disableIncBrandNameTic, setDisableIncBrandNameTic] = useState(false); // ERX Requirement changes

  const [packageSizeOptions, setPackageSizeOptions] = useState([]); // ERX Requirement changes

  // ERX Requirement changes for Controlled Substance
  const generateLabelForControlledSubstanceReferenceField = () => {
    let lbl = 'ARN';
    console.log("patientState: ", patientState);
    switch (patientState) {
      case 'NSW':
        lbl = 'Authorisation Number';
        break;
      case 'NT':
        lbl = 'Authorisation Number';
        break;
      case 'WA':
        lbl = 'Authority Number';
        break;
      case 'TAS':
        lbl = 'Authority Number';
        break;
      case 'QLD':
        lbl = 'Approval Number';
        break;
      case 'ACT':
        lbl = 'Approval Number';
        break;
      case 'SA':
        lbl = 'Permit Number';
        break;
      case 'VIC':
        lbl = 'Warrant Number';
        break;
    };
    setControlledSubstanceReferenceFieldLabel(lbl);
  }


  // set
  useEffect(() => {
    props.setIsPBSAuthorityRequired(false);
    // generateLabelForControlledSubstanceReferenceField();

    // cancel drug list popup when click outside of the popup
    const handleClickOutside = event => {
      if (drugListRef.current && !drugListRef.current.contains(event.target)) {
        setDrugList([]);
        setIsShowDrugList(false);
      }
    };
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // get MIMS token and Expiry
  const MIMSToken = props.MIMSToken;
  const MIMSTokenExpiryTimestamp = props.MIMSTokenExpiryTimestamp;

  // debounce input
  const debounce = (fn, t) => {
    if (timeoutCount) clearTimeout(timeoutCount);
    const newTimeoutCount = setTimeout(fn, t);
    setTimeoutCount(newTimeoutCount);
  };

  const createFormData = (values, isSave) => {
    let formData = {};

    if (props.data.doctorDetails !== null && props.data.patientDetails !== null) {
      if (isSave) {
        formData.scriptNumber = Math.floor(100000 + Math.random() * 900000);
      } else {
        formData.scriptNumber = "123456";
      }

      if (formik.values.scriptOwing) {
        props.setIsScriptOwing(true);
      } else {
        props.setIsScriptOwing(false);
      }

      formData.isSave = isSave;
      formData.pbsSafetyCardholder = false;
      formData.pbsSafetyNetConcessionHolder = false;
      formData.PBS = formik.values.PBS;
      formData.pbsRpbs = formik.values.PBS;
      formData.RPBS = false;
      formData.PBSCode = formik.values.pbsCode
        ? formik.values.pbsCode.trim().split(" ")[0]
        : PBSCodeForErx.trim().split(" ")[0];
      formData.brandSubstitution = formik.values.brandSubstitution;
      formData.PBSManufacturerCode = formik.values.pbsManuCode || "";
      formData.drugName =
        (formik.values.drugName ||
          `${formik.values.manualInputGenericName} (${formik.values.manualInputBrandName})`) +
        " ";
      formData.strength = formik.values.strength + " ";
      formData.formType = formik.values.formType;
      formData.dose = formik.values.dose + " ";
      formData.frequency = formik.values.frequency + " ";
      formData.medTake = formik.values.withFood
        ? "with food"
        : formik.values.emptyStomach
          ? "on an empty stomach"
          : "";
      formData.isUnusualDose = formik.values.isUnusualDose ? true : false;
      formData.medQuanity =
        "[" +
        MIMSUtil.translateMedQuantityToNumber(formik.values.medQuantity) +
        "]" +
        " " +
        "(" +
        MIMSUtil.wordsTranslate(
          MIMSUtil.translateMedQuantityToNumber(formik.values.medQuantity)
        ) +
        ")";
      formData.Repeats =
        formik.values.numberOfRepeat === 1
          ? formik.values.numberOfRepeat + " " + "Repeat"
          : formik.values.numberOfRepeat + " " + "Repeats";
      formData.authorityRequiredPBS = formik.values.authorityRequiredPBS;
      formData.SAC = formik.values.authorityRequiredPBS
        ? formik.values.SAC
          ? MIMSUtil.splitCodeFromSAC(formik.values.SAC)
          : ""
        : "";
      formData.APN = formik.values.authorityRequiredPBS
        ? formik.values.APN
        : "";
      formData.regulation24 = formik.values.regulation24;
      formData.routeAdministration =
        routeAdministration || formik.values.manualInputRoute;
      // formData.moleculeName = MIMSUtil.firstLetterUpperCase(
      //   moleculeName || formik.values.manualInputGenericName
      // );

      if (props.assessmentData?.assessmentType === "Medicinal Cannabis") {
        formData.otherPrescriptionDetails = props.data.doctorDetails.authPrescriberSchemaNoMC + "\n" + formik.values.otherPrescriptionDetails;
      } else if (props.assessmentData?.assessmentType === "Smoking Cessation") {
        formData.otherPrescriptionDetails = props.data.doctorDetails.authPrescriberSchemaNo + "\n" + formik.values.otherPrescriptionDetails;
      } else {
        formData.otherPrescriptionDetails = formik.values.otherPrescriptionDetails;
      }

      formData.scriptOwing = formik.values.scriptOwing;
      formData.reasonForPrescribe = formik.values.reasonForPrescribe;
      // formData.miniIntervalRepeats = formik.values.miniIntervalRepeats + "";

      formData.annotationTextFromDoctor = formik.values.annotationTextFromDoctor;
      formData.PrescribedItem_Reserved_04 = formik.values.PrescribedItem_Reserved_04;
      formData.PrescribedItem_Reserved_01 = MIMSUtil.wordsTranslate(
        MIMSUtil.translateMedQuantityToNumber(formik.values.medQuantity)
      );

      formData.controlledSubstanceReferenceFieldLabel = controlledSubstanceReferenceFieldLabel;
      formData.controlledSubstanceReference = formik.values.controlledSubstanceReference;
      formData.miniIntervalRepeats = formik.values.numberOfRepeat > 0 ? formik.values.miniIntervalRepeats + "" : '';


      formData.category = formik.values.category + "";
      formData.indication = formik.values.indication;
      formData.isNotToMySL = formik.values.isNotToMySL;
      // formData.brandName = brandName || formik.values.manualInputBrandName;

      formData.isSendToPharmacy = formik.values.isSendToPharmacy;
      formData.sendToPharmacyValue = formik.values.sendToPharmacyValue;

      // if we have manual drug input then we will customise the brand name and AIP Status
      let brandName = formik.values.brandName || formik.values.manualInputBrandName;
      if (isDrugManuallyInput) {
        brandName = `${formik.values.manualInputGenericName} ${formik.values.strength} ${formik.values.formType} ${formik.values.isIncludeBrandName ? `(${formik.values.manualInputBrandName})` : ''}`;
      }
      formData.brandName = brandName;

      // if we have manual drug input then we will use brand name as molecule name
      let moleculeNameToSet = moleculeName || formik.values.manualInputGenericName;
      if (isDrugManuallyInput) {
        formData.moleculeName = brandName;
      } else {
        formData.moleculeName = moleculeNameToSet
      }

      formData.ingredient = ingredient;
      // formData.AIPStatus = AIPStatus;

      //! if we have manual drug input then  we will customise the brand name and AIP status
      formData.AIPStatus = isDrugManuallyInput ? brandName : (formik.values.AIPStatus || AIPStatus);

      formData.itemGenericIntention = formik.values.itemGenericIntention;

      formData.isDrugManuallyInput = isDrugManuallyInput;

      // Optional ERX Codes for ePrescription
      formData.AMT_MP = formik.values.AMT_MP;
      formData.AMT_MPP = formik.values.AMT_MPP;
      formData.AMT_TPP = formik.values.AMT_TPP;
      formData.AMT_MPUU = formik.values.AMT_MPUU;
      formData.AMT_TP = formik.values.AMT_TP;
      formData.AMT_TPUU = formik.values.AMT_TPUU;
      formData.AMT_CTPP = formik.values.AMT_CTPP;

      formData.isIncludeBrandName = formik.values.isIncludeBrandName;

      formData.isExtemp = formik.values.isExtemp;

      formData.doctorName =
        "Dr. " + props.data.doctorDetails.firstName + " " + props.data.doctorDetails.lastName;
      formData.doctorId = props.data.doctorDetails.doctorId;
      formData.doctorfirstName = props.data.doctorDetails.firstName;
      formData.doctorlastName = props.data.doctorDetails.lastName;
      formData.doctorSignature = props.data.doctorDetails.signature || "";
      formData.doctorPrescriberNo = props.data.doctorDetails.prescriberNo;
      formData.doctorAHPRA = props.data.doctorDetails.AHPRA;
      formData.doctorQualification = props.data.doctorDetails.doctorQualification;
      formData.doctorProviderNo = props.data.doctorDetails.medicalProviderNo;
      formData.doctorPhoneNumber = props.data.doctorDetails.phoneNumber;
      formData.doctorEmail = props.data.doctorDetails.email;
      formData.eRxId = props.data.doctorDetails.eRxId;
      formData.doctorQualification = props.data.doctorDetails.doctorQualification;
      formData.doctorHPII = props.data.doctorDetails.HPIIInfo
        ? props.data.doctorDetails.HPIIInfo.HPIINumber
        : "";

      formData.medicareNo = formatMedicareNo(
        props.data.patientDetails.medicareNumber
      );
      formData.refrenceNumber =
        props.data.patientDetails.refNumerOnMedicareCard;
      formData.patientName =
        props.data.patientDetails.firstName +
        " " +
        props.data.patientDetails.lastName;
      formData.patientSex = props.data.patientDetails.gender;
      formData.patientEmail = props.data.patientDetails.email;
      formData.patientPhoneNumber = props.data.patientDetails.phoneNumber;
      let dateOfBirthArr = props.data.patientDetails.dateOfBirth.split("-");
      formData.dateOfBirth =
        dateOfBirthArr[2] + dateOfBirthArr[1] + dateOfBirthArr[0];
      formData.patientAddress =
        (props.data.patientDetails.address.unitNumber != null &&
        props.data.patientDetails.address.unitNumber.trim() !== "" &&
        props.data.patientDetails.address.unitNumber !== undefined
          ? props.data.patientDetails.address.unitNumber + "/"
          : "") +
        props.data.patientDetails.address.streetNumber +
        " " +
        props.data.patientDetails.address.streetName;
      formData.patientAddress1 =
        props.data.patientDetails.address.suburb +
        " " +
        props.data.patientDetails.address.state +
        " " +
        props.data.patientDetails.address.postCode;
      formData.patientIHI = props.data.patientDetails.IHIInfo
        ? props.data.patientDetails.IHIInfo.IHINumber || ""
        : "";
      formData.patientIHINumberStatus = props.data.patientDetails.IHIInfo
        ? props.data.patientDetails.IHIInfo.IHINumberStatus || ""
        : "";
      formData.patientIHIRecordStatus = props.data.patientDetails.IHIInfo
        ? props.data.patientDetails.IHIInfo.IHIRecordStatus || ""
        : "";
      formData.patientId = props.data.patientDetails.patientId;

      formData.todayDate = getFormattedDate(new Date().toISOString());
      formData.todayTime = getFormattedTime(new Date().toISOString());

      formData.patientDetails = {
        firstName: props.data.patientDetails.firstName,
        middleName: props.data.patientDetails.middleName,
        lastName: props.data.patientDetails.lastName,
        email: props.data.patientDetails.email,
        medicareNumber: props.data.patientDetails.medicareNumber,
        address: {
          unitNumber: props.data.patientDetails.address.unitNumber,
          streetName: props.data.patientDetails.address.streetName,
          suburb: props.data.patientDetails.address.suburb,
          state: props.data.patientDetails.address.state,
          postCode: props.data.patientDetails.address.postCode
        },
        gender: props.data.patientDetails.gender,
        dateOfBirth: props.data.patientDetails.dateOfBirth,
        phoneNumber: props.data.patientDetails.phoneNumber,
        refrenceNumber: props.data.patientDetails.refNumerOnMedicareCard,
        DVANumber: props.data.patientDetails.DVANumber || '',
        _id: props.data.patientDetails._id
      };

      formData.PBSAuth = finalNumber;
      formData.isUnusualQty = isManuallyEnterQty;
      formData.isEPrescribing = true;

      formData.isS8Drug = s8DrugAuthModalStatus; // if doctor select S8 drug then we need to log this

      let data = new FormData();
      data.append("keys", JSON.stringify(formData));
      data.append("type", "Prescription");

      return data;
    }
  };

  const previewDoc = () => {
    let dt = createFormData(formik.values, false);
    props.onPreviewSubmit(dt);
  };

  const saveDoc = values => {
    props.setIsPBSAuthorityRequired(authorityRequiredPBS);
    let dt = createFormData(values, true);

    // drugDataToSave will be useful during senting the email from backend for a treatment plan
    let drugDataToSave = {
      name: formik.values.drugName,
      strength: formik.values.strength,
      formType: formik.values.formType,
      quantity: formik.values.medQuantity,
      repeats: formik.values.numberOfRepeat,
      regulation24: formik.values.regulation24,
      dose: formik.values.dose,
      frequency: formik.values.frequency,
      otherPrescriptionDetails: formik.values.otherPrescriptionDetails
    };

    if (props.assessmentData?.assessmentType === "Medicinal Cannabis") {
      drugDataToSave = Object.assign(drugDataToSave, {
        category: formik.values.category,
        // indication: getIndicationText(formik.values.indication),
        miniIntervalRepeats: formik.values.miniIntervalRepeats
      });
    }

    props.onSaveSubmit(dt, drugDataToSave);
    setTimeout(() => {
      formik.resetForm();
      resetFieldsOfProductDetails();
    }, 1000);
  };

  const formik = useFormik({
    initialValues: {
      brandName: "", // instead of using state variable, I'm using formik. Leaving state variable as it is
      drugdata: "",
      drugName: "",
      pbsManuCode: "",
      pbsCode: "",
      SAC: "",
      APN: "",
      strength: "",
      formType: "",
      dose: "",
      frequency: "",
      medQuantity: "",
      // selectQtyOfMedication: "",
      numberOfRepeat: 0,
      PBS: false,
      brandSubstitution: false,
      isIncludeBrandName: true,
      emptyStomach: false,
      withFood: false,
      isUnusualDose: false,
      authorityRequiredPBS: false,
      regulation24: false,
      otherPrescriptionDetails: "",
      scriptOwing: false,
      reasonForPrescribe: "",
      annotationTextFromDoctor: "", // ERX Requirement
      PrescribedItem_Reserved_04: "", // NSW if required - ERX Requirement
      controlledSubstanceReference: "", // ERX requirement
      miniIntervalRepeats: "",
      isNotToMySL: true,
      isSendToPharmacy: false,

      AMT_MP: "", // optional code ERX required
      AMT_MPP: "", // optional code ERX required
      AMT_TPP: "", // optional code ERX required
      AMT_MPUU: "", // optional code ERX required
      AMT_TP: "", // optional code ERX required
      AMT_TPUU: "", // optional code ERX required
      AMT_CTPP: "", // optional code ERX required

      sendToPharmacyValue: "DosingPoint",
      manualInputGenericName: "",
      manualInputBrandName: "",
      manualInputRoute: "",
      manualInputRoute: "",
      itemGenericIntention: "G", //ItemGenericIntention - Populate with "B" for items included in the List of Excluded Medicinal Items (LEMI) only or "G" for all other items. Please see document "eRx Payload Requirements for Active Ingredient Prescribing (AIP)" in the Vendor Welcome Pack or ePrescribing Github.
      category: "", // auto inserted from MIMS - for now it's manual selection
      indication: "" // for medicinal cannabis, indication we put on consult note
    },
    validationSchema: Yup.object({
      drugdata: Yup.string().required("This field is required"),
      // drugName: Yup.string().required("This field is required"),
      drugName: Yup.string(),
      PBS: Yup.boolean(),
      pbsManuCode: Yup.string(),
      pbsCode: Yup.string(),
      // SAC: (!isDrugPrefilled && authorityRequiredPBS) ? Yup.string() : Yup.string().required("Streamlined Authority Code is required"),
      // APN: (!isDrugPrefilled && authorityRequiredPBS) ? Yup.string() : Yup.string().required("Authority Approval Number is required"),
      // strength: Yup.string().required("This field is required"),
      strength: Yup.string(),
      // formType: Yup.string().required("This field is required"),
      formType: Yup.string(),
      // dose: Yup.string().required("This field is required"),
      dose: Yup.string(),
      // frequency: Yup.string().required("This field is required"),
      frequency: Yup.string(),
      numberOfRepeat: Yup.number()
        .required("Number of Repeats is required")
        .min(0, "This field must be equal or greater than 0")
        .max(maxNumberOfRepeats, "Maximum Number of Repeats Exceeded"),
      medQuantity:
        !isDrugPrefilled ||
        isManuallyEnterQty ||
        medQuantitySelectWithManualInput.length === 0
          ? Yup.number()
            .max(maxQuantityOfMed, "Exceeds Maximum Qty Available on the PBS")
            .required("Quantity of the Medication is required")
          : Yup.string().required("Quantity of the Medication is required"),
      otherPrescriptionDetails: Yup.string().max(
        50,
        "Maximum 50 characters are allowed"
      ),
      reasonForPrescribe: Yup.string().max(
        50,
        "Maximum 50 characters are allowed"
      ),
      annotationTextFromDoctor: Yup.string().max(50, "Maxium 50 characters are allowed"),
      PrescribedItem_Reserved_04: Yup.string().max(80, "Max 80 charaters are allowed"),
      controlledSubstanceReference: Yup.string(),
      miniIntervalRepeats: !props.hideS8 ? Yup.number() : Yup.number().when("numberOfRepeat", {
        is: value => +value > 0,
        then: Yup.number().required("This field is required")
      }),
      category: !props.hideS8 ? Yup.string() : Yup.string().required("This field is required"),
      // indication: !props.hideS8 ? Yup.string() : Yup.string().required("This field is required"),
      // selectQtyOfMedication: Yup.string().required("This field is required"),
      // maxNumberOfRepeats
      manualInputGenericName: Yup.string(),
      manualInputBrandName: Yup.string(),
      manualInputRoute: Yup.string().required("Please enter route"),
    }),
    onSubmit: values => {
      saveDoc(values);
    }
  });

  const getDrugsData = () => {
    if (formik.values.drugdata.length < 3) return;
    let apiCallParam = {
      reqType: "GET",
      reqURL: `${getProductsByIngredientApiRoute}/${formik.values.drugdata}/${MIMSToken}`,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        let drugList = [];
        drugList.push({
          productId: "manually_enter",
          productName: "Manually Enter Drug Information"
        });
        const drugSearchResByIngredient = res.data.data;

        if (
          drugSearchResByIngredient &&
          drugSearchResByIngredient.length > 0 &&
          typeof drugSearchResByIngredient[0] !== "string"
        ) {
          drugList.push({
            productId: "ingredient",
            productName: "------ Search Result by Active Ingredient ------"
          });
          drugList = drugList.concat(drugSearchResByIngredient);
        }


        let apiCallParam = {
          reqType: "GET",
          reqURL: `${getProductsByBrandApiRoute}/${formik.values.drugdata}/${MIMSToken}`,
          dataObj: {},
          params: {},
          headers: {},
          successCallback: res => {
            const drugSearchResByBrand = res.data.data;

            if (
              drugSearchResByBrand &&
              drugSearchResByBrand.length > 0 &&
              typeof drugSearchResByBrand[0] !== "string"
            ) {
              drugList.push({
                productId: "brand",
                productName: "------ Search Result by Brand ------"
              });
              drugList = drugList.concat(drugSearchResByBrand);
            }

            // setLoading(false);
            setDrugList(drugList);
            setIsShowDrugList(true);
          },
          failureCallback: err => {

          },
          showPopUp: false
        };
        setApiCallParams(apiCallParam);
      },
      failureCallback: err => {

      },
      showPopUp: false
    };
    if (formik.values.drugdata.length > 3) {
      setApiCallParams(apiCallParam);
    }
  };

  // deal with Drug Database input to call MIMS API
  useEffect(() => {
    if (isSelected === true) return;
    if (!formik || !formik.values || !formik.values.drugdata) {
      setIsShowDrugList(false);
      //TODO: finish reset fields in form when the keyword of "Search Drug Database" is deleted
      resetFieldsOfProductDetails();

      return;
    }
    if (formik.values.drugdata.length < 3 && formik.values.drugdata.length > 1)
      return;
    if (isDrugManuallyInput === true) return;

    debounce(() => {
      // setLoading(true);
      getDrugsData();
    }, 800);
    return () => {
      // to make sure isSelected=true only in one render cycle, isSelected=true means the value is changed by selection rather than input
      setIsSelected(false);
    };
  }, [formik.values.drugdata]);

  // get drug product details by productId from MIMS API
  useEffect(() => {
    if (Object.keys(selectedDrug).length === 0) return;

    setLoading(true);
    let apiCallParam = {
      reqType: "GET",
      reqURL: `${getDrugProductDetailsByIdApiRoute}/${selectedDrug.productId}/${MIMSToken}`,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        setLoading(false);
        if (res.data && res.data.data) {
          prefillFormByDrugProductDetails(res.data.data);
        }
      },
      failureCallback: err => {
        setLoading(false);
      },
      showPopUp: false
    };
    setApiCallParams(apiCallParam);
    // setApiCallParams({
    //   reqType: "GET",
    //   reqUrl:,
    //   successCallback: res => {

    //   },
    //   failureCallback: err => {
    //     
    //   }
    // });
  }, [selectedDrug]);

  // set PBS change
  useEffect(() => {
    // if (!formik.values.drugdata) return;

    if (!formik.values.PBS) {
      if (!formik.values.pbsCode) {
        clearPBSData();
        return;
      }
      cachePBSDetails();
    } else {
      if (Object.keys(prescriptionDataCache).length === 0) return;
      restorePBSDetails();
    }
  }, [formik.values.PBS]);

  // set Quantity of Medication field
  useEffect(() => {
    if (formik.values.medQuantity === "Manually Enter Qty") {
      formik.values.medQuantity = "";
      setIsManuallyEnterQty(true);
    } else {
      setMedQuantity(formik.values.medQuantity);
    }
  }, [formik.values.medQuantity]);

  // set PBSCode field
  useEffect(() => {
    if (PBSCodeSelect.length <= 1) return;

    clearPBSData();
    const code = formik.values.pbsCode.trim().split(" ")[0];
    getPBSDetailsFromMIMS(code);
  }, [formik.values.pbsCode]);

  // set Quantity of Medication field
  useEffect(() => {
    if (!formik.values.authorityRequiredPBS) {
      formik.values.SAC = "";
      formik.values.APN = "";
      setSAC("");
      setSACSelect([]);
      setAPN("");
      setIsAPNRequired(false);
    }

    setAuthorityRequiredPBS(formik.values.authorityRequiredPBS);
  }, [formik.values.authorityRequiredPBS]);

  // set withFood and emptyStomach, only one of them could be true
  useEffect(() => {
    setEmptyStomach(formik.values.emptyStomach);

    if (formik.values.emptyStomach && formik.values.withFood) {
      formik.values.withFood = false;
      setWithFood(false);
    }
  }, [formik.values.emptyStomach]);

  // set withFood and emptyStomach, only one of them could be true
  useEffect(() => {
    setWithFood(formik.values.withFood);

    if (formik.values.withFood && formik.values.emptyStomach) {
      formik.values.emptyStomach = false;
      setEmptyStomach(false);
    }
  }, [formik.values.withFood]);

  /* useEffect(() => {
    let otherPrescriptionDetails = formik.values.otherPrescriptionDetails;
    if (formik.values.regulation24) {
      if (!otherPrescriptionDetails) {
        otherPrescriptionDetails += "Regulation 24\r\n";
      } else {
        if (!otherPrescriptionDetails.includes("Regulation 24")) {
          otherPrescriptionDetails =
            "Regulation 24\r\n" + otherPrescriptionDetails;
        }
      }
    } else {
      if (otherPrescriptionDetails.includes("Regulation 24\r\n")) {
        otherPrescriptionDetails = otherPrescriptionDetails.replace(
          "Regulation 24\r\n",
          ""
        );
      }
      if (otherPrescriptionDetails.includes("Regulation 24\r")) {
        otherPrescriptionDetails = otherPrescriptionDetails.replace(
          "Regulation 24\r",
          ""
        );
      }
      if (otherPrescriptionDetails.includes("Regulation 24\n")) {
        otherPrescriptionDetails = otherPrescriptionDetails.replace(
          "Regulation 24\n",
          ""
        );
      }
      if (otherPrescriptionDetails.includes("Regulation 24")) {
        otherPrescriptionDetails = otherPrescriptionDetails.replace(
          "Regulation 24",
          ""
        );
      }
    }
    formik.values.otherPrescriptionDetails = otherPrescriptionDetails;
  }, [formik.values.regulation24]); */

  useEffect(() => {

    // ! DO NOT TOUCH - ERX DANGER
    // if (!acgNameInAcgs.toLocaleLowerCase().includes("semaglutide")) {
    if (formik.values.isIncludeBrandName && !isDrugManuallyInput) {
      if (AIPStatus === "LMBC") {
        formik.values.drugName = ingredient + " " + strength + " (" + brandName + ")";
      } else if (AIPStatus === "LEMI") {
        formik.values.drugName = brandName;
      } else {
        formik.values.drugName = ingredient + " " + strength + " (" + brandName + ")";
      }
    } else {
      if (formik.values.drugName) {
        formik.values.drugName = ingredient + " " + strength;
      }
    }

    setDrugName(formik.values.drugName);

    if (drugDetails) {
      fillOptionalePresParameters(drugDetails);
    }
    // }
  }, [formik.values.isIncludeBrandName]);


  useEffect(() => {
    formik.values.isIncludeBrandName = true;
    formik.handleChange("isIncludeBrandName");
  }, []);

  const selectDrug = drug => {
    resetFieldsOfProductDetails();

    if (drug.productName === "Manually Enter Drug Information") {
      formik.values.drugdata = "Manually Enter Drug Information";
      // setSelectedDrug({});
      // setIsSelected(true);
      setIsDrugManuallyInput(true);
      setIsDrugPrefilled(false);
      setIsManuallyEnterQty(true);
      setDrugList([]);
      setIsShowDrugList(false);
    } else {
      formik.values.drugdata = drug.productName || "";
      // handleSelectedDrugForInstantSwitch(drug);
      setIsSelected(true);
      setIsDrugPrefilled(true);
      setIsManuallyEnterQty(false);
      setSelectedDrug(drug);
      setDrugList([]);
      setIsShowDrugList(false);
    }
  };



  const drugToCheckForMinInterval = (drugDetails) => {
    const stateSchedules = drugDetails.stateSchedules || [];
    const drugToCheck = {
      'NSW': ['S4B', 'S8'],
      'ACT': ['S8'],
      'WA': ['S8'],
      'QLD': ['S8'],
      'NT': ['S8'],
      'TAS': ['S8', 'S4D'],
    };
    let flag = false;

    stateSchedules.forEach(schedule => {
      const state = schedule.state;
      const schedules = schedule.schedules;

      if (drugToCheck[state]) {
        drugToCheck[state].forEach(drug => {
          if (schedules.includes(drug)) {
            flag = true;
          }
        });
      }
    });

    const isS8Drug = drugDetails.poisonClassification && drugDetails.poisonClassification.poisonClasses && drugDetails.poisonClassification.poisonClasses.length && drugDetails.poisonClassification.poisonClasses[0] === "S8" ? true : false;
    setShowMinRepeatInterval(flag || isS8Drug);

  }

  const fillOptionalePresParameters = (drugProductDetails, packageSizeIndexToUse = 0) => {

    const isLMBC = drugProductDetails.aip && drugProductDetails.aip.lmbc ? true : false; // requires brand name
    const isLEMI = drugProductDetails.aip && drugProductDetails.aip.lemi ? true : false;

    formik.values.itemGenericIntention = isLEMI ? "B" : "G";


    setDisableIncBrandNameTic(isLEMI);

    // if there is no API in MIMS then we use AMT
    const ifNoAIP = !drugProductDetails.aip && drugProductDetails.amt && drugProductDetails.amt.length;
    const isAIPAndNOLMBC_LEMI = (isLMBC || isLEMI || AIPStatus === "NONE") && drugProductDetails.amt && drugProductDetails.amt.length;
    if (ifNoAIP || isAIPAndNOLMBC_LEMI) {
      if (drugProductDetails.amt[0].mpps && drugProductDetails.amt[0].mpps.length && drugProductDetails.amt[0].mpps[packageSizeIndexToUse].mppName) {

        let MIMSBrandName =
          drugProductDetails.amt &&
            drugProductDetails.amt[0] &&
            drugProductDetails.amt[0].tpName
            ? drugProductDetails.amt[0].tpName.split('(')[0].trim()
            : drugProductDetails.productName ? drugProductDetails.productName : (drugProductDetails.brand
              ? drugProductDetails.brand.brandName
              : "");
        // let MIMSBrandName = drugProductDetails.productName; // updates by bianca on 31 Jan 2025

        let MIMSAIPStatus = isLEMI ? drugProductDetails.amt[0].tpps[packageSizeIndexToUse].tppName : drugProductDetails.amt[0].mpps[packageSizeIndexToUse].mppName;

        console.log("MIMSAIPStatus: ", MIMSAIPStatus);

        // Please ask Jake
        // if there is any ml or mg or something like 10mg then we remove it if not need. ERX term: additional info
        const tempBrandNameOtherHalf = MIMSAIPStatus.split(",")[1] || '';
        const isThereAnyLetters = /[A-Za-z]/.test(tempBrandNameOtherHalf);
        if (!isThereAnyLetters) {
          MIMSAIPStatus = MIMSAIPStatus.split(",")[0];
        }

        if (formik.values.isIncludeBrandName && !isLEMI) {
          // setAIPStatus(`${MIMSAIPStatus} (${MIMSBrandName})`);
          // setBrandName(`${MIMSAIPStatus} (${MIMSBrandName})`);
          formik.values.brandName = `${MIMSAIPStatus} (${MIMSBrandName})`;
          setMoleculeName(`${MIMSAIPStatus} (${MIMSBrandName})`);
          formik.values.AIPStatus = `${MIMSAIPStatus} (${MIMSBrandName})`;
        } else {
          // setAIPStatus(`${MIMSAIPStatus}`);
          // setBrandName(`${MIMSAIPStatus}`);
          formik.values.brandName = `${MIMSAIPStatus}`;
          setMoleculeName(`${MIMSAIPStatus}`);
          formik.values.AIPStatus = `${MIMSAIPStatus}`;
        }
      }
    } else {
      let MIMSBrandName = drugProductDetails.productName ? drugProductDetails.productName : (drugProductDetails.brand
        ? drugProductDetails.brand.brandName
        : "");
      formik.values.AIPStatus = `${MIMSBrandName}`;
      setAIPStatus(MIMSBrandName.substring(0, 400));
      setMoleculeName(`${MIMSBrandName}`);
      formik.values.brandName = `${MIMSBrandName}`;
    }

    // OPTIONAL codes for ePrescription
    if (drugProductDetails.amt && drugProductDetails.amt.length && drugProductDetails.amt[0].mpps && drugProductDetails.amt[0].mpps.length && drugProductDetails.amt[0].mpps[packageSizeIndexToUse].mppCode) {
      formik.values.AMT_MPP = drugProductDetails.amt[0].mpps[packageSizeIndexToUse].mppCode;
    }

    if (formik.values.isIncludeBrandName && drugProductDetails.amt && drugProductDetails.amt.length && drugProductDetails.amt[0].tpCode) {
      formik.values.AMT_TP = drugProductDetails.amt[0].tpCode;
    }


    if (formik.values.isIncludeBrandName && drugProductDetails.amt && drugProductDetails.amt.length && drugProductDetails.amt[0].tpps && drugProductDetails.amt[0].tpps.length && drugProductDetails.amt[0].tpps[packageSizeIndexToUse].tppCode) {
      formik.values.AMT_TPP = drugProductDetails.amt[0].tpps[packageSizeIndexToUse].tppCode;
    }

  }

  const handleSelectedDrugForInstantSwitch = (selectedDrugData) => {
    console.log("Selected Drug -> ", selectedDrugData);
    if (selectedDrugData && selectedDrugData.productName) {
      const isNicovapeQSelected = selectedDrugData.productName.toLowerCase().includes("nicovape");
      if (isNicovapeQSelected) {
        handleNicovapeQDrug(selectedDrugData);
      }

      const isAllowSyncSelected = selectedDrugData.productName.toLowerCase().includes("allo sync");
      if (isAllowSyncSelected) {
        handleAlloSyncDrug(selectedDrugData);
      }

      const isVeevSelected = selectedDrugData.productName.toLowerCase().includes("veev");
      if (isVeevSelected) {
        handleVeevDrug(selectedDrugData);
      }

      const isWildByInstinctSelected = selectedDrugData.productName.toLowerCase().includes("wild by instinct");
      if (isWildByInstinctSelected) {
        handleWildByInstinctDrug(selectedDrugData);
      }

      //! For instant switch drugs we will always use manual qty and we will not use any values of drug related to QTY and repeats
      formik.setFieldValue("medQuantity", "");
      setIsManuallyEnterQty(true);
      formik.setFieldValue("numberOfRepeat", "");
    }
  };

  const handleSelectedDrugForInstantHush = (selectedDrugData) => {
    if (selectedDrugData && selectedDrugData.productName) {
      // if instant hush special drug is selected then we have to fillup some details in prescription data
      const selectedIHDrug = _.find(INSTANT_HUSH_SPECIAL_DRUGS_FILLED, (o) => {
        return selectedDrugData.productName.toLowerCase().includes(o);
      });
      switch (selectedIHDrug) {
        case "sildenafil":
          fillSildenafilDrugDetails();
          break;
        case "tadalafil":
          fillTadalafilDrugDetails();
          break;
        case "avanafil":
          fillAvanafilDrugDetails(); // avanafil and spedra is same (brand name and drug name difference)
          break;
        case "spedra":
          fillAvanafilDrugDetails();
          break;
        case "vardenafil":
          fillVardenafilDetails(); // vardenafil and levitra is same (brand name and drug name difference)
          break;
        case "levitra":
          fillVardenafilDetails();
          break;
      }
    }
  };

  const handleSelectedDrugForTickRegulation24 = (selectedDrugInfo) => {
    if (selectedDrugInfo && selectedDrugInfo.productName) {
      const isRegulationChkTicked = _.find(REGULATION_24_DRUG_SELECTED, (o) => {
        return selectedDrugInfo.productName.toLowerCase().includes(o);
      });
      if (isRegulationChkTicked && isRegulationChkTicked.length) {
        formik.values.regulation24 = true;
        formik.setFieldValue("regulation24", true);
      }
    }
  };

  const handleNicovapeQDrug = (selectedDrugData) => {
    if (selectedDrugData.productName.toLowerCase().includes("nicovape q 59") || selectedDrugData.productName.toLowerCase().includes("nicovape q sd")) {
      formik.setFieldValue("dose", "1 inhalation prn");
      formik.setFieldValue("frequency", "(max 1 cartridge per day)");
      setIsManuallyEnterQty(true);
      formik.setFieldValue("medQuantity", "");
      formik.setFieldValue("numberOfRepeat", "");
    } else if (selectedDrugData.productName.toLowerCase().includes("nicovape q")) {
      formik.setFieldValue("dose", "in conjunction with Nicovape Q cartridges");
      formik.setFieldValue("frequency", "(separate purchase required)");
      setIsManuallyEnterQty(true);
      formik.setFieldValue("medQuantity", "");
      formik.setFieldValue("numberOfRepeat", "");
    } else if (selectedDrugData.productName.toLowerCase().includes("nicovape")) {

    }
  };

  const handleAlloSyncDrug = (selectedDrugData) => {
    if (selectedDrugData.productName.toLowerCase().includes("allo sync") || selectedDrugData.productName.toLowerCase().includes("allo sync")) {
      formik.setFieldValue("dose", "1 inhalation prn");
      formik.setFieldValue("frequency", "(max 1 cartridge per day)");
      setIsManuallyEnterQty(true);
      formik.setFieldValue("medQuantity", "");
    }
  };

  const handleVeevDrug = (selectedDrugData) => {
    if (selectedDrugData.productName.toLowerCase().includes("veev") || selectedDrugData.productName.toLowerCase().includes("veev")) {
      formik.setFieldValue("dose", "1 inhalation prn");
      formik.setFieldValue("frequency", "(max 1 cartridge per day)");
      setIsManuallyEnterQty(true);
      formik.setFieldValue("medQuantity", "");
    }
  };
  const handleWildByInstinctDrug = (selectedDrugData) => {
    if (selectedDrugData.productName.toLowerCase().includes("wild by instinct") || selectedDrugData.productName.toLowerCase().includes("wild by instinct")) {
      formik.setFieldValue("dose", "1 inhalation prn");
      formik.setFieldValue("frequency", "(max 1 cartridge per day)");
      setIsManuallyEnterQty(true);
      formik.setFieldValue("medQuantity", "");
    }
  };

  const fillSildenafilDrugDetails = () => {
    formik.setFieldValue("dose", "1 tab");
    formik.setFieldValue("frequency", "1 hour prior to activity");
    setIsManuallyEnterQty(true);
    formik.setFieldValue("medQuantity", "");
    formik.setFieldValue("numberOfRepeat", "");
  };

  const fillTadalafilDrugDetails = () => {
    formik.setFieldValue("dose", "1 tab");
    formik.setFieldValue("frequency", "1-2 hour prior to activity");
    if (formik.values.strength == "20 mg" || formik.values.strength == "20mg") {
      setIsManuallyEnterQty(true);
      formik.setFieldValue("medQuantity", "");
    }
    formik.setFieldValue("numberOfRepeat", "");
  };

  const fillAvanafilDrugDetails = () => {
    formik.setFieldValue("dose", "1 tab");
    formik.setFieldValue("frequency", "15-30 minutes prior to activity");
    setIsManuallyEnterQty(true);
    formik.setFieldValue("medQuantity", "");
    formik.setFieldValue("numberOfRepeat", "");
  };

  const fillVardenafilDetails = () => {
    formik.setFieldValue("dose", "1 tab");
    formik.setFieldValue("frequency", "1 hour prior to activity");
    setIsManuallyEnterQty(true);
    formik.setFieldValue("medQuantity", "");
    formik.setFieldValue("numberOfRepeat", "");
  };

  const prefillFormByDrugProductDetails = drugProductDetails => {

    setDrugDetails(drugProductDetails);

    // handle "S8" drug
    if (
      drugProductDetails.poisonClassification &&
      drugProductDetails.poisonClassification.poisonClasses
    ) {
      const poisonClasses =
        drugProductDetails.poisonClassification.poisonClasses;
      if (poisonClasses.length > 0 && poisonClasses[0] === "S8") {
        setIsPoisonClassS8(true);

        if (!props.hideS8) {
          return;
        }
      } else if (poisonClasses.length > 0 && poisonClasses[0] === "S4") {
        setIsPoisonClassS4(true);
      }
    }

    const productName = drugProductDetails.productName;

    // handle extemporaneous drug
    let acgName = "";

    if (drugProductDetails.acgs[0] && drugProductDetails.acgs[0].acgName) {
      acgName = drugProductDetails.acgs[0].acgName;
      setAcgNameInAcgs(acgName);

      // if Ingredient includes "Codeine", set maxNumberOfRepeats as 0
      if (acgName.includes("Codeine")) setMaxNumberOfRepeats(0);
    }

    if (extemporaneousDrugList && extemporaneousDrugList.length > 0) {
      if (extemporaneousDrugList.indexOf(productName) > -1) {
        setIsExtemporaneousDrug(true);
        formik.values.isExtemp = true;
        return;
      }
    } else if (productName.includes("Extemporaneous")) {
      formik.values.isExtemp = true;
    }

    if (discontinuedDrugList && discontinuedDrugList.length > 0) {
      if (discontinuedDrugList.indexOf(productName) > -1) {
        setIsDiscontinuedDrug(true);
        return;
      }
    }

    if (outOfStockDrugError && outOfStockDrugError.length > 0) {
      const outOfStockIndex = outOfStockDrugError.map(e => e.drug).indexOf(productName);
      console.log("Hey here: ", outOfStockDrugError, productName, outOfStockIndex);
      if (outOfStockIndex > -1) {
        setIsOutOfStockDrug(outOfStockDrugError[outOfStockIndex].message);
        return;
      }
    }

    if (commonDrugBlockListErrors && commonDrugBlockListErrors.length > 0) {
      let isIncludedInDrug = commonDrugBlockListErrors.map(e => acgName.toLowerCase().includes(e.drug));
      const commonDrugBlockIndex = isIncludedInDrug.indexOf(true);
      console.log("Hey here for common drug block list: ", commonDrugBlockListErrors, productName, commonDrugBlockIndex);

      // to match with API value and our custom array
      let extrasToMatch = {};

      extrasToMatch['drugTakenRoute'] = drugProductDetails.roas && drugProductDetails.roas[0] ? drugProductDetails.roas[0].toLowerCase() : '';

      // check our customer array has any 'extras' key in that object? If yes then we need to match with API values and display the error
      let objKeysLength = commonDrugBlockIndex !== -1 && commonDrugBlockListErrors[commonDrugBlockIndex] && commonDrugBlockListErrors[commonDrugBlockIndex]['extras'] ? Object.keys(commonDrugBlockListErrors[commonDrugBlockIndex]['extras']).length : 0;
      if (objKeysLength) {
        let hasError = false;
        for (let key in commonDrugBlockListErrors[commonDrugBlockIndex]['extras']) {
          if (commonDrugBlockListErrors[commonDrugBlockIndex]['extras'][key] === extrasToMatch[key]) {
            hasError = true;
            break;
          }
        }
        if (hasError) {
          setIsOutOfStockDrug(commonDrugBlockListErrors[commonDrugBlockIndex].message);
          return;
        }
      } else if (commonDrugBlockIndex > -1) {
        setIsOutOfStockDrug(commonDrugBlockListErrors[commonDrugBlockIndex].message);
        return;
      }
    }

    let specialDrugType = "";

    // handle S4 warning drug
    if (S4WarningDrugList && S4WarningDrugList.length > 0) {
      const S4WarningDrugListLength = S4WarningDrugList.length;

      if (productName) {
        for (var i = 0; i < S4WarningDrugListLength; i++) {
          var index = productName.indexOf(S4WarningDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_WARNING";
            break;
          }
        }
      }

      if (acgName && specialDrugType !== "S4_WARNING") {
        for (var i = 0; i < S4WarningDrugListLength; i++) {
          var index = acgName.indexOf(S4WarningDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_WARNING";
            break;
          }
        }
      }
    }

    // handle S4 disabled drug
    if (S4DisabledDrugList && S4DisabledDrugList.length > 0) {
      const S4DisabledDrugListLength = S4DisabledDrugList.length;

      //! for ERX we need to allow this drug to be entered. Example: phentermine - So you need to comment this code when you need to check for ERX
      if (productName) {
        for (var i = 0; i < S4DisabledDrugListLength; i++) {
          var index = productName.indexOf(S4DisabledDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_DISABLED";
            break;
          }
        }
      }

      if (acgName && specialDrugType !== "S4_DISABLED") {
        for (var i = 0; i < S4DisabledDrugListLength; i++) {
          var index = acgName.indexOf(S4DisabledDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_DISABLED";
            break;
          }
        }
      }
    }

    // handle drug which is containing "Codeine" but not in S4D or S4W list
    if (!specialDrugType && acgName.includes("Codeine"))
      specialDrugType = "S4_WARNING";

    setSpecialDrugType(specialDrugType);
    if (specialDrugType === "S4_DISABLED") return;

    //handle drug which is containing "isotretinoin"
    let isIsotretinoin = false;

    if (isotretinoinDrugList && isotretinoinDrugList.length > 0) {
      const isotretinoinDrugListLength = isotretinoinDrugList.length;

      if (productName) {
        for (let i = 0; i < isotretinoinDrugListLength; i++) {
          let index = productName
            .toLowerCase()
            .indexOf(isotretinoinDrugList[i]);

          if (index > -1) {
            isIsotretinoin = true;
            break;
          }
        }
        if (isIsotretinoin) {
          setIsIsotretinoinDrugList(true);
          return;
        }
      }

      if (acgName) {
        for (let i = 0; i < isotretinoinDrugListLength; i++) {
          let index = acgName.toLowerCase().indexOf(isotretinoinDrugList[i]);
          if (index > -1) {
            isIsotretinoin = true;
            break;
          }
        }
        if (isIsotretinoin) {
          setIsIsotretinoinDrugList(true);
          return;
        }
      }
    }

    //handle drug which is containing "isotretinoin"
    let isInPersonGPDrug = false;

    if (inPersonGPDrugList && inPersonGPDrugList.length > 0) {
      const inPersonGPDrugListLength = inPersonGPDrugList.length;

      if (productName) {
        for (let i = 0; i < inPersonGPDrugListLength; i++) {
          let index = productName.toLowerCase().indexOf(inPersonGPDrugList[i]);

          if (index > -1) {
            isInPersonGPDrug = true;
            break;
          }
        }
        if (isInPersonGPDrug) {
          setIsInPersonGPDrugList(true);
          return;
        }
      }

      if (acgName) {
        for (let i = 0; i < inPersonGPDrugListLength; i++) {
          let index = acgName.toLowerCase().indexOf(inPersonGPDrugList[i]);
          if (index > -1) {
            isInPersonGPDrug = true;
            break;
          }
        }
        if (isInPersonGPDrug) {
          setIsInPersonGPDrugList(true);
          return;
        }
      }
    }

    // find the strength first because now Bianca wants to append strength string to drug
    // set routeAdministration, formType, strength, moleculeName
    const routeAdministration =
      drugProductDetails.roas && drugProductDetails.roas[0];
    let formType =
      drugProductDetails.productPacks[0].productPackItems[0].dosageForm;
    let strength = "";
    let moleculeName = "";

    if (
      drugProductDetails.vis.length > 0 &&
      drugProductDetails.vis[0].molecules && drugProductDetails.vis[0].molecules.length
    ) {
      const molecules = drugProductDetails.vis[0].molecules;
      molecules.forEach((item, index) => {
        let moleculeNameToAddIntoStrength = '';
        if (item.moleculePerVol && item.moleculePerVolUnit) {
          moleculeNameToAddIntoStrength += `/${item.moleculePerVol}${item.moleculePerVolUnit}`;
        }

        if (index === 0) {
          strength =
            (item.moleculeStrength +
              (item.moleculeStrength === "0" ? "" : item.moleculeStrengthUnit)) + moleculeNameToAddIntoStrength;
          moleculeName = item.moleculeName;

        } else {
          strength =
            (strength +
              " / " +
              item.moleculeStrength +
              (item.moleculeStrength === "0" ? "" : item.moleculeStrengthUnit)) + moleculeNameToAddIntoStrength;
          moleculeName = moleculeName + " + " + item.moleculeName;
        }
      });
    } else {
      strength = "-";
    }

    // set drug name
    // let MIMSBrandName =
    //   drugProductDetails.amt &&
    //     drugProductDetails.amt[0] &&
    //     drugProductDetails.amt[0].tpName
    //     ? drugProductDetails.amt[0].tpName.split('(')[0].trim()
    //     : drugProductDetails.brand
    //       ? drugProductDetails.brand.brandName
    //       : "";
    let MIMSBrandName = drugProductDetails.productName; // updates by bianca on 31 Jan 2025
    let MIMSIngredient =
      drugProductDetails.acgs &&
        drugProductDetails.acgs[0] &&
        drugProductDetails.acgs[0].acgName
        ? drugProductDetails.acgs[0].acgName
        : "";
    let drugName = MIMSIngredient + ' ' + strength;

    formik.values.brandName = MIMSBrandName;
    setBrandName(MIMSBrandName);
    setIngredient(MIMSIngredient);


    // we need package sizes for different names. Example drug: betamethasone - it has 5 g, 15 g and 50 g packages
    let packageSizeOptionsArr = [];
    if (drugProductDetails.amt && drugProductDetails.amt[0]) {
      for (let i = 0; i < drugProductDetails.amt[0].mpps.length; i++) {
        packageSizeOptionsArr.push({
          _id: i,
          val: drugProductDetails.amt[0].mpps[i].mppName.split(",")[1].trim(),
          name: drugProductDetails.amt[0].mpps[i].mppName.split(",")[1].trim(),
        });
      }
    }
    setPackageSizeOptions(packageSizeOptionsArr);


    /* // removed when integrate AIP rules
    if (multipleBrandNameDrugList && multipleBrandNameDrugList.length > 0) {
      if (
        multipleBrandNameDrugList.indexOf(drugProductDetails.brand.brandName) >
        -1
      ) {
        drugName = drugProductDetails.productName;
      } else {
        drugName = MIMSIngredient;
      }
    } else {
      drugName = MIMSIngredient;
    }
    */

    // handle "Include Brand Name on Prescription" is ticked
    if (formik.values.isIncludeBrandName) {
      drugName = MIMSIngredient + " (" + MIMSBrandName + ")";
    }

    // if doctor select combination pack then we will have multiple drug names and multiple strengths
    // updated on 30 July 2024
    let isCombinationPack = (productName.toLowerCase().includes('combination pack') || productName.toLowerCase().includes('combo pack'));
    if (drugProductDetails.acgs.length > 1 && isCombinationPack) {
      drugName = '';
      drugProductDetails.acgs.forEach((drug, index) => {
        drugName = drugName + drug.acgName;
        if (index < drugProductDetails.acgs.length - 1) {
          drugName = drugName + '/';
        }
      })
    }


    // apply rules of AIP
    let MIMSAIPStatus = "NONE";

    if (drugProductDetails.aip) {
      if (drugProductDetails.aip.lmbc === true) {
        MIMSAIPStatus = "LMBC";
        if (!formik.values.isIncludeBrandName) {
          formik.values.isIncludeBrandName = true;
          drugName = drugName + " (" + MIMSBrandName + ")";
        }
      }

      if (drugProductDetails.aip.lemi === true) {
        MIMSAIPStatus = "LEMI";
        if (!formik.values.isIncludeBrandName) {
          formik.values.isIncludeBrandName = true;
        }
        drugName = MIMSBrandName;
      }
    }


    if (productName.toLowerCase().includes("combination pack")) {
      formik.values.drugName = productName;
    } else {
      formik.values.drugName = drugName;
    }

    // updated on 30 July 2024 - If combination pack is selected then we will input multiple drug names in strength and drug name will be product name for display purpose and strength will be drug name(s)
    formik.values.drugName = isCombinationPack ? productName : drugName;

    // formik.values.drugName = drugName;

    //! Specific to ERX - DO NOT TOUCH - until you fix with MIMS and PRES-24
    if (acgName.toLocaleLowerCase().includes("semaglutide")) {
      formik.values.drugName = drugName + ' ' + drugProductDetails.productPacks[0].productPackName;
      drugName = formik.values.drugName;
    }

    setAIPStatus(MIMSAIPStatus.substring(0, 400));
    formik.values.AIPStatus = MIMSAIPStatus.substring(0, 400);
    setDrugName(drugName);


    if (isCombinationPack) {
      strength = drugName; // we will have multiple drugnames here
      formType = "Combo Pack";
    }

    formik.values.formType = formType;
    formik.values.strength = strength;
    setRouteAdministration(routeAdministration);

    formik.values.manualInputRoute = routeAdministration;

    setFormType(formType);
    setStrength(strength);
    setMoleculeName(moleculeName);

    // handle manually input MedQty
    const drugProductPacks = drugProductDetails.productPacks;
    let medQuantity;
    let medQuantityCopy;
    let minMedQuantity;
    let medQuantitySelectWithManualInput = [];
    let medQuantitySelect = [];

    if (drugProductPacks && drugProductPacks.length === 1) {
      medQuantity = MIMSUtil.getQuantityOfMedicationText(
        drugProductPacks[0].productPackName
      );
      medQuantityCopy = medQuantity;

      if (medQuantity.includes("x")) {
        minMedQuantity = medQuantity.split("x")[1].trim();
      } else {
        minMedQuantity = medQuantity;
      }
      medQuantitySelectWithManualInput = [medQuantity, "Manually Enter Qty"];
    } else {
      drugProductPacks.forEach((item, index) => {
        medQuantitySelect.push(
          MIMSUtil.getQuantityOfMedicationText(item.productPackName)
        );
      });
      medQuantitySelect = MIMSUtil.removeDuplicate(medQuantitySelect);
      if (medQuantitySelect.length === 1) {
        medQuantity = medQuantitySelect[0];
        medQuantityCopy = medQuantity;
        if (medQuantity.includes("x")) {
          minMedQuantity = medQuantity.split("x")[1].trim();
        } else {
          minMedQuantity = medQuantity;
        }
        medQuantitySelect = [];
        medQuantitySelectWithManualInput = [];
        medQuantitySelectWithManualInput = [medQuantity, "Manually Enter Qty"];
      } else {
        minMedQuantity = MIMSUtil.getMinValueFromArray(medQuantitySelect);
        medQuantitySelectWithManualInput = [];
        medQuantitySelectWithManualInput = medQuantitySelect.slice();

        // if the quantity format is like "[28,28x3]", then reverse to make greater number on the top
        if (
          medQuantitySelectWithManualInput[1] &&
          medQuantitySelectWithManualInput[1].includes("x")
        )
          medQuantitySelectWithManualInput.reverse();

        medQuantitySelectWithManualInput.push("Manually Enter Qty");
      }
    }

    // set medQuantitySelectWithManualInput to Formik
    formik.values.medQuantity = medQuantitySelectWithManualInput[0];
    setMedQuantity(medQuantity);
    setMedQuantityCopy(medQuantityCopy);
    setMinMedQuantity(minMedQuantity);
    setMedQuantitySelect(medQuantitySelect);
    setMedQuantitySelectWithManualInput(medQuantitySelectWithManualInput);

    // check if it is PBS drug
    if (drugProductDetails.pbs && drugProductDetails.pbs.length > 0) {
      const PBSCodesLength = drugProductDetails.pbs.length;
      const PBSManufacturerCode =
        drugProductDetails.pbs[0].pbsManufacturerCodes[0];
      let PBSCodeList = [];

      formik.values.pbsManuCode = PBSManufacturerCode;
      setPBSManufacturerCode(PBSManufacturerCode);

      for (var i = 0; i < PBSCodesLength; i++) {
        PBSCodeList.push(drugProductDetails.pbs[i].pbsCode);
      }
      if (PBSCodeList && PBSCodeList.length === 1) {
        formik.values.pbsCode = PBSCodeList[0];
        setPBSCode(PBSCodeList[0]);

        getPBSDetailsFromMIMS(PBSCodeList[0], drugProductDetails);
      } else {
        PBSCodeList.sort();
        getMultiplePBSCodeAndText(PBSCodeList, drugProductDetails);
      }
    }

    // if drugs required min interval between repeats then it goe here
    console.log("Drug Details are here ------- ", drugProductDetails);
    drugToCheckForMinInterval(drugProductDetails);

    // fill optional fileds for ePres
    fillOptionalePresParameters(drugProductDetails);
  };

  const fillCustomDataIntoForms = drugProductDetails => {
    handleSelectedDrugForInstantSwitch(drugProductDetails);
    handleSelectedDrugForInstantHush(drugProductDetails);
    handleSelectedDrugForTickRegulation24(drugProductDetails);
  };

  // get PBSDetails From MIMS API
  const getPBSDetailsFromMIMS = (PBSCodeWithoutText, drugProductDetails) => {
    setLoading(true);
    console.log("======== PBSCodeWithoutText ==========", PBSCodeWithoutText);
    promisePBSDetailsRequest(PBSCodeWithoutText)
      .then(res => {
        setLoading(false);
        let PBSDetails = res;

        if (!PBSDetails) return;

        let PBSCodeForErx;
        let PBSManufacturerCode;
        let RPBS;
        let RPBSPrefilled;
        let PBS;
        let PBSPrefilled;
        let PBSCodeTemp;
        let blockedPBSType;

        if (PBSDetails.pbsType !== "PBS/RPBS" && PBSDetails.pbsType !== "PBS") {
          PBSCodeForErx = formik.values.pbsCode;
          PBSManufacturerCode = "";
          RPBS = false;
          RPBSPrefilled = false;
          PBS = false;
          PBSPrefilled = false;
          PBSCodeTemp = "";
          blockedPBSType = "";

          if (PBSDetails.pbsType === "RPBS") {
            if (PBSCodeSelect && PBSCodeSelect.length > 0) {
              let index = PBSCodeSelect.indexOf(PBSCodeForErx.trim());

              if (index > -1) {
                let newElement =
                  PBSCodeSelect[index].trim().split(" ")[0] +
                  " " +
                  "RPBS Only (Private Script)";
                PBSCodeSelect.splice(index, 1, newElement);
                PBSCodeTemp = newElement;
              }
            }
          } else {
            blockedPBSType = PBSDetails.pbsType;
          }

          formik.values.pbsCode = PBSCodeTemp;
          formik.values.PBS = PBS;
          formik.values.pbsManuCode = PBSManufacturerCode;
          setPBSCodeSelect(PBSCodeSelect);
          setPBSCodeForErx(PBSCodeForErx);
          setPBSManufacturerCode(PBSManufacturerCode);
          setRPBS(RPBS);
          setRPBSPrefilled(RPBSPrefilled);
          setPBS(PBS);
          setPBSPrefilled(PBSPrefilled);
          setPBSCode(PBSCodeTemp);
          setBlockedPBSType(blockedPBSType);

          return;
        } else {
          PBS = true;
          PBSPrefilled = true;
          RPBS = false;
          RPBSPrefilled = false;

          formik.values.PBS = PBS;
          setPBS(PBS);
          setPBSPrefilled(PBSPrefilled);
          setRPBS(RPBS);
          setRPBSPrefilled(RPBSPrefilled);
        }

        let maxNumberOfRepeats = Math.min(0, parseInt(PBSDetails.repeats || 0)); // for instant switch only we allow any number of repeats

        // if Ingredient includes "Codeine", set maxNumberOfRepeats as 0
        if (acgNameInAcgs.includes("Codeine")) maxNumberOfRepeats = 0;

        let maxQtyUnits = PBSDetails.maxQtyUnits;
        let isManuallyEnterQty = false;
        setMaxNumberOfRepeats(maxNumberOfRepeats);
        setMaxQtyUnits(maxQtyUnits);
        setIsManuallyEnterQty(isManuallyEnterQty);

        let medQuantitySelectFromPBSDetails;
        let minMedQuantity;

        if (PBSDetails.pbsBrands && PBSDetails.pbsBrands.length > 0) {
          PBSManufacturerCode =
            formik.values.pbsManuCode ||
            PBSDetails.pbsBrands[0].manufacturerCode;
          const medQuantityFromPBSDetails = MIMSUtil.getMedQuantityFromPBSDetails(
            PBSDetails.pbsBrands
          );
          medQuantitySelectFromPBSDetails =
            medQuantityFromPBSDetails.medQuantitySelectFromPBSDetails;
          minMedQuantity = medQuantityFromPBSDetails.minMedQuantity;

          formik.values.pbsManuCode = PBSManufacturerCode;
          setPBSManufacturerCode(PBSManufacturerCode);
          setMinMedQuantity(minMedQuantity);
          setMedQuantitySelectFromPBSDetails(medQuantitySelectFromPBSDetails);
        }

        if (
          maxQtyUnits &&
          maxQtyUnits.length > 0 &&
          maxQtyUnits >= minMedQuantity
        ) {
          formik.values.medQuantity = "";
          setMedQuantity("");

          // value of medQuantitySelectFromPBSDetails, minMedQuantity, maxQtyUnits is set by useState in async way, so pass them to function is necessary
          handleMaxQtyUnits(
            medQuantitySelectFromPBSDetails,
            minMedQuantity,
            maxQtyUnits
          );
        }

        const PBSRestrictions = PBSDetails.restrictions;
        let authorityRequiredPBS;
        let restrictionList = [];

        if (PBSRestrictions.length === 0) {
          authorityRequiredPBS = false;
        } else {
          restrictionList = MIMSUtil.handleRestrictionText(PBSRestrictions);
          const PBSRestrictionType = PBSRestrictions[0].restrictionType;

          if (
            PBSRestrictionType === "Unrestricted" ||
            PBSRestrictionType === "Restricted"
          ) {
            authorityRequiredPBS = false;
          } else {
            authorityRequiredPBS = true;

            if (PBSRestrictionType === "Streamlined authority") {
              let APN = "";
              let isAPNRequired = false;
              let SAC = "";
              let SACSelect = [];

              if (PBSRestrictions.length === 1) {
                let streamlinedText = MIMSUtil.getStreamlinedText(
                  PBSRestrictions[0].restrictionPreview
                );
                SAC = PBSRestrictions[0].streamlinedCode + streamlinedText;
              } else {
                PBSRestrictions.forEach((value, key) => {
                  if (
                    value.streamlinedCode &&
                    value.streamlinedCode.length > 0
                  ) {
                    SACSelect.push(
                      value.streamlinedCode +
                      MIMSUtil.getStreamlinedText(value.restrictionPreview)
                    );
                  }
                });
              }

              formik.values.SAC = SAC;
              formik.setFieldValue("SAC", SAC);
              formik.values.APN = APN;
              setAPN(APN);
              setIsAPNRequired(isAPNRequired);
              setSAC(SAC);
              setSACSelect(SACSelect);
            }

            if (
              PBSRestrictionType === "Online authority required" ||
              PBSRestrictionType === "Written authority required"
            ) {
              let isAPNRequired = true;
              let SAC = "";
              let SACSelect = [];

              formik.values.SAC = SAC;
              setIsAPNRequired(isAPNRequired);
              setSAC(SAC);
              setSACSelect(SACSelect);
            }
          }
        }

        formik.values.authorityRequiredPBS = authorityRequiredPBS;
        setRestrictionList(restrictionList);
        setAuthorityRequiredPBS(authorityRequiredPBS);

        fillCustomDataIntoForms(drugProductDetails);
      })
      .catch(err => {
        console.error("getPBSDetailsFromMIMS err", err);
        setLoading(false);
      });
  };

  const getMultiplePBSCodeAndText = async (PBSCodeList, drugProductDetails) => {
    // create array of promise request
    const promiseRequestArr = await PBSCodeList.map(item => promisePBSDetailsRequest(item));

    // deal with request array by Promise.all
    setLoading(true);
    Promise.all(promiseRequestArr)
      .then(res => {
        console.log("Got the responce in Promise: -> ", res);
        setLoading(false);
        let PBSCodeSelect = [];

        res.forEach((data, index) => {
          console.log("Got the data into promise array -> ", data);
          let PBSCode = data.pbsCode;
          let prescriberTypes = data.prescriberTypes;

          if (prescriberTypes.indexOf("MP") > -1) {
            let PBSDetailsRestrictions = data.restrictions;

            if (PBSDetailsRestrictions) {
              if (PBSDetailsRestrictions.length === 0) {
                PBSCode = PBSCode + " " + "Not Restricted";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType === "Unrestricted"
              ) {
                PBSCode = PBSCode + " " + "Unrestricted";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType === "Restricted"
              ) {
                PBSCode = PBSCode + " " + "Restricted";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType ===
                "Streamlined authority"
              ) {
                PBSCode = PBSCode + " " + "Streamlined Authority Code";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType ===
                "Online authority required"
              ) {
                PBSCode = PBSCode + " " + "Authority Approval Number";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType ===
                "Written authority required"
              ) {
                PBSCode = PBSCode + " " + "Authority Approval Number";
              }
              PBSCodeSelect.push(PBSCode);
            }
          }
        });

        if (PBSCodeSelect.length === 1) {
          let PBSCode = PBSCodeSelect[0].trim().split(" ")[0];
          formik.values.pbsCode = PBSCode;
          setPBSCode(PBSCode);

          getPBSDetailsFromMIMS(PBSCode);
        } else {
          formik.values.pbsCode = "";
          setPBSCodeSelect(PBSCodeSelect);
        }

        fillCustomDataIntoForms(drugProductDetails);
      })
      .catch(err => {
        setLoading(false);
        console.error("Promise err", err);
      });
  };

  // create promise of PBSDetails API request for each PBS code
  const promisePBSDetailsRequest = PBSCode => {
    return new Promise((resolve, reject) => {
      if (PBSCode) {
        let apiCallParam = {
          reqType: "GET",
          reqURL: `${getDrugPBSDetailsByPBSCodeApiRoute}/${PBSCode}/${MIMSToken}`,
          dataObj: {},
          params: {},
          headers: {},
          successCallback: res => {
            console.log("Checking response in PBS Details -> ", res.data.data);
            if (res.data && res.data.data) {
              resolve(res.data.data);
            } else {
              resolve({});
            }
          },
          failureCallback: err => {
            reject(err);
          },
          showPopUp: false
        };
        setApiCallParams(apiCallParam);
      } else {
        resolve({});
      }
    });
  };

  const handleMaxQtyUnits = (
    medQuantitySelectFromPBSDetails,
    minMedQuantity,
    maxQtyUnits
  ) => {
    let medQuantitySelectOnMaxQtyUnits = [];

    if (
      medQuantitySelectFromPBSDetails &&
      medQuantitySelectFromPBSDetails.length > 0
    ) {
      let medQuantitySelectWithManualInput = [];

      if (medQuantitySelectFromPBSDetails[0].includes("x")) {
        medQuantitySelectOnMaxQtyUnits = medQuantitySelectFromPBSDetails;
        medQuantitySelectWithManualInput = medQuantitySelectOnMaxQtyUnits.slice();

        // if the quantity format is like "[28,28x3]", then reverse to make greater number on the top
        medQuantitySelectWithManualInput.reverse();

        medQuantitySelectWithManualInput.push("Manually Enter Qty");
        medQuantitySelectWithManualInput = MIMSUtil.removeDuplicate(
          medQuantitySelectWithManualInput
        );
      } else {
        let intMinMedQuantity = parseInt(minMedQuantity);
        let intMaxQtyUnits = parseInt(maxQtyUnits);

        for (let i = 1; i <= intMaxQtyUnits; i++) {
          if (i % intMinMedQuantity === 0) {
            medQuantitySelectOnMaxQtyUnits.push(i);
          }
        }

        medQuantitySelectWithManualInput = medQuantitySelectOnMaxQtyUnits.slice();
        medQuantitySelectWithManualInput.push("Manually Enter Qty");
        medQuantitySelectWithManualInput = MIMSUtil.removeDuplicate(
          medQuantitySelectWithManualInput
        );
      }

      formik.values.medQuantity = medQuantitySelectWithManualInput[0];
      setMedQuantitySelectWithManualInput(medQuantitySelectWithManualInput);
    }

    // get the max quantity of medication from selection list to limit the manual input
    if (medQuantitySelectOnMaxQtyUnits.length > 0) {
      // get the last element, change it to number, keep it, when un-tick PBS cache it
      let lastIndex = medQuantitySelectOnMaxQtyUnits.length - 1;
      let maxQuantityOfMed = MIMSUtil.translateMedQuantityToNumber(
        medQuantitySelectOnMaxQtyUnits[lastIndex]
      );

      setMaxQuantityOfMed(maxQuantityOfMed);
    }

    if (medQuantitySelectOnMaxQtyUnits.length === 1) {
      let medQuantity = medQuantitySelectOnMaxQtyUnits[0];
      medQuantitySelectOnMaxQtyUnits = [];

      formik.values.medQuantity = medQuantity;
      setMedQuantity(medQuantity);
    }

    setMedQuantitySelectOnMaxQtyUnits(medQuantitySelectOnMaxQtyUnits);
  };

  const resetFieldsOfProductDetails = () => {
    prescriptionDataCache = {};

    formik.values.brandName = "";

    formik.values.pbsCode = "";
    formik.values.PBS = false;
    formik.values.pbsManuCode = "";
    formik.values.drugName = "";
    formik.values.strength = "";
    formik.values.formType = "";
    formik.values.dose = "";
    formik.values.frequency = "";
    formik.values.withFood = "";
    formik.values.emptyStomach = "";
    formik.values.isUnusualDose = "";
    formik.values.medQuantity = "";
    formik.values.numberOfRepeat = "";
    formik.values.regulation24 = false;
    formik.values.otherPrescriptionDetails = "";
    formik.values.authorityRequiredPBS = false;
    formik.values.SAC = "";
    formik.values.APN = "";
    formik.values.scriptOwing = false;
    formik.values.reasonForPrescribe = "";
    formik.values.annotationTextFromDoctor = "";
    formik.values.PrescribedItem_Reserved_04 = "";
    formik.values.controlledSubstanceReference = "";
    formik.values.miniIntervalRepeats = "";
    formik.values.category = "";
    formik.values.indication = "";
    formik.values.isNotToMySL = true;
    formik.values.isSendToPharmacy = false;
    formik.values.sendToPharmacyValue = "DosingPoint";
    formik.values.brandSubstitution = false;
    formik.values.isIncludeBrandName = true;
    formik.values.manualInputGenericName = "";
    formik.values.manualInputBrandName = "";
    formik.values.manualInputRoute = "";

    formik.values.AMT_MP = "";
    formik.values.AMT_MPP = "";
    formik.values.AMT_TPP = "";
    formik.values.AMT_MPUU = "";
    formik.values.AMT_TP = "";
    formik.values.AMT_TPUU = "";
    formik.values.AMT_CTPP = "";

    setIsDrugManuallyInput(false);
    setIsDrugPrefilled(false);
    setSelectedDrug({});
    setPBSPrefilled(false);
    setPBSCodeSelect([]);
    setPBSCode("");
    setPBS(false);
    setPBSManufacturerCode("");
    setDrugName("");
    setStrength("");
    setFormType("");
    setWithFood(false);
    setEmptyStomach(false);
    setMedQuantity("");
    setMedQuantityCopy("");
    setMedQuantitySelect([]);
    setMedQuantitySelectWithManualInput([]);
    setMinMedQuantity("");
    setMaxQtyUnits("");
    setMaxQuantityOfMed(99999999);
    setMedQuantitySelectOnMaxQtyUnits([]);
    setIsManuallyEnterQty(false);
    setIsPoisonClassS8(false);
    setIsPoisonClassS4(false);
    setIsExtemporaneousDrug(false);
    setSpecialDrugType("");
    setBlockedPBSType("");
    setRestrictionList([]);
    setMaxNumberOfRepeats(9999999999); // we allow any number of repeats for Instant Switch
    setAuthorityRequiredPBS(false);
    setSAC("");
    setSACSelect([]);
    setAPN("");
    setIsAPNRequired(false);
    setRouteAdministration("");
    setMoleculeName("");
    setOtherPrescriptionDetails("");
    setPBSCodeForErx("");
    setMedQuantitySelectFromPBSDetails([]);
    setAcgNameInAcgs("");
    setIsDiscontinuedDrug(false);
    setIsIsotretinoinDrugList(false);
    setIsInPersonGPDrugList(false);
    setIsOutOfStockDrug(false);
    setBrandName("");
    setIngredient("");
    setAIPStatus("NONE");
    setDisableIncBrandNameTic(false);
  };

  const cachePBSDetails = () => {
    // if (!formik.values.pbsCode) return;

    setPBSCodeForErx(formik.values.pbsCode);

    prescriptionDataCache.pbsCode = formik.values.pbsCode;
    prescriptionDataCache.PBSCodeSelect = PBSCodeSelect;
    prescriptionDataCache.maxNumberOfRepeats = maxNumberOfRepeats;
    prescriptionDataCache.authorityRequiredPBS =
      formik.values.authorityRequiredPBS;
    prescriptionDataCache.SAC = formik.values.SAC;
    prescriptionDataCache.APN = formik.values.APN;
    prescriptionDataCache.SACSelect = SACSelect;
    prescriptionDataCache.restrictionList = restrictionList;
    prescriptionDataCache.medQuantity = formik.values.medQuantity;
    prescriptionDataCache.medQuantitySelectOnMaxQtyUnits = medQuantitySelectOnMaxQtyUnits;
    prescriptionDataCache.medQuantitySelectWithManualInput = medQuantitySelectWithManualInput;
    prescriptionDataCache.maxQuantityOfMed = maxQuantityOfMed;

    formik.values.pbsCode = "";
    setPBSCode("");
    setPBSCodeSelect([]);
    setMaxNumberOfRepeats(99999999); // we allow any number of repeats for Instant Switch
    formik.values.authorityRequiredPBS = false;
    setAuthorityRequiredPBS(false);
    formik.values.SAC = "";
    setSAC("");
    setSACSelect([]);
    formik.values.APN = "";
    setAPN("");
    setRestrictionList([]);
    setMedQuantitySelectOnMaxQtyUnits([]);

    formik.values.medQuantity = medQuantityCopy;
    let medQuantitySelectWithManualInputTemp = [];
    if (medQuantityCopy) {
      medQuantitySelectWithManualInputTemp = [
        medQuantityCopy,
        "Manually Enter Qty"
      ];
    } else if (medQuantitySelect && medQuantitySelect.length > 0) {
      medQuantitySelectWithManualInputTemp = medQuantitySelect.slice();
      medQuantitySelectWithManualInputTemp.push("Manually Enter Qty");
    }

    setMedQuantitySelectWithManualInput(medQuantitySelectWithManualInputTemp);
    setIsManuallyEnterQty(false);
    setMaxQuantityOfMed(99999999);
  };

  const restorePBSDetails = () => {
    console.log("------- Restoring PBS Details -------");
    if (Object.getOwnPropertyNames(prescriptionDataCache).length === 0) return;

    formik.values.pbsCode = prescriptionDataCache.pbsCode;
    setPBSCode(prescriptionDataCache.pbsCode);
    setPBSCodeSelect(prescriptionDataCache.PBSCodeSelect);
    setMaxNumberOfRepeats(prescriptionDataCache.maxNumberOfRepeats);
    formik.values.authorityRequiredPBS =
      prescriptionDataCache.authorityRequiredPBS;
    setAuthorityRequiredPBS(prescriptionDataCache.authorityRequiredPBS);
    formik.values.SAC = prescriptionDataCache.SAC;
    setSAC(prescriptionDataCache.SAC);
    formik.values.APN = prescriptionDataCache.APN;
    setAPN(prescriptionDataCache.APN);
    setSACSelect(prescriptionDataCache.SACSelect);
    setRestrictionList(prescriptionDataCache.restrictionList);
    formik.values.medQuantity = prescriptionDataCache.medQuantity;
    setMedQuantity(prescriptionDataCache.medQuantity);
    setMedQuantitySelectOnMaxQtyUnits(
      prescriptionDataCache.medQuantitySelectOnMaxQtyUnits
    );
    setMedQuantitySelectWithManualInput(
      prescriptionDataCache.medQuantitySelectWithManualInput
    );
    setMaxQuantityOfMed(prescriptionDataCache.maxQuantityOfMed);
    setPBSCodeForErx("");
    setIsManuallyEnterQty(false);
  };

  const clearPBSData = () => {
    // formik.values.PBS = false;
    setPBS(false);
    setRestrictionList([]);
    setMaxNumberOfRepeats(99999999); // we allow any number of repeats for Instant switch for private scripts only.
    formik.values.authorityRequiredPBS = false;
    setAuthorityRequiredPBS(false);
    formik.values.SAC = "";
    setSAC("");
    setSACSelect([]);
    formik.values.APN = "";
    setAPN("");
    setIsAPNRequired(false);
    setMaxQuantityOfMed(99999999);
    setBlockedPBSType("");
    setMedQuantitySelectWithManualInput([]);
  };

  const getPBSAuthorityPrescriptionNum = (ebsnumber, prescriberNum) => {
    if (finalNumber) return finalNumber;

    let doctorPrescriberNoArr = prescriberNum.substr(
      prescriberNum.length - 5,
      4
    );
    let pointerCancatadd;
    let pointerCancataddn;
    let pointerCancatArray;
    let sum = 0;
    let final;
    let zz;
    let finalNumberTemp;

    ebsnumber = Number(ebsnumber);
    if (ebsnumber) {
      pointerCancatadd = Number(ebsnumber) + 1;
    } else {
      pointerCancatadd = Number(doctorPrescriberNoArr);
      props.updateEbsNumber(pointerCancatadd);
    }

    pointerCancataddn = "000" + pointerCancatadd;
    pointerCancatArray = pointerCancataddn.split("");
    pointerCancatArray.map(n => {
      sum += Number(n);
    });
    final = sum / 9;
    zz = final.toFixed(2).split(".")[1];
    zz = zz.toString()[0];
    finalNumberTemp = pointerCancataddn + zz;

    setFinalNumber(finalNumberTemp);
    return finalNumberTemp;
  };

  // get PBS Authority Prescription Number
  const PBSAuth = getPBSAuthorityPrescriptionNum(
    props.data.doctorDetails.ebsnumber,
    props.data.doctorDetails.prescriberNo
  );

  const getFormattedMedicareNumAndIRN = (medicareNumber, refrenceNumber) => {
    let medicareNo;
    if (medicareNumber !== "" && medicareNumber.length >= 10) {
      medicareNumber = medicareNumber.replace(/\s+/g, "");
      let med = medicareNumber;
      let medicareNumber1 = med.substring(0, 4);
      let med1 = medicareNumber;
      let medicareNumber2 = med1.substring(4, 9);
      let med2 = medicareNumber;
      let medicareNumber3 = med2.substring(9, 10);
      if (refrenceNumber !== "")
        medicareNo =
          medicareNumber1 +
          " " +
          medicareNumber2 +
          " " +
          medicareNumber3 +
          " - " +
          refrenceNumber;
      else
        medicareNo =
          medicareNumber1 + " " + medicareNumber2 + " " + medicareNumber3;
    } else {
      medicareNo = "N/A";
    }

    return medicareNo;
  };

  // get medicare Number and IRN with white space format
  const medicareNo = getFormattedMedicareNumAndIRN(
    props.data.patientDetails.medicareNumber,
    props.data.patientDetails.refNumerOnMedicareCard
  );

  let buttonDisabled = false;

  if (
    Object.keys(formik.errors).length > 0 ||
    !formik.values.drugdata ||
    (!formik.values.drugName && !isDrugManuallyInput) ||
    // (!formik.values.manualInputBrandName && isDrugManuallyInput) ||
    (!formik.values.manualInputGenericName && isDrugManuallyInput) ||
    (!formik.values.manualInputRoute && isDrugManuallyInput) ||
    !formik.values.strength ||
    !formik.values.formType ||
    !formik.values.dose ||
    !formik.values.frequency ||
    !formik.values.medQuantity ||
    isNaN(formik.values.numberOfRepeat) ||
    (PBSCodeSelect.length > 0 && !formik.values.pbsCode) ||
    formik.values.numberOfRepeat > maxNumberOfRepeats ||
    (authorityRequiredPBS && !formik.values.SAC && !formik.values.APN) ||
    (isDrugPrefilled &&
      formik.values.PBS &&
      (!formik.values.pbsCode || !formik.values.pbsManuCode))
    // (!formik.values.miniIntervalRepeats && isPoisonClassS4)
  ) {
    buttonDisabled = true;
  } else {
    buttonDisabled = false;
  }


  useEffect(() => {
    if (isPoisonClassS8) {
      console.log("Doctor selected S8 Drug");
      setS8DrugAuthModalStatus(true); // ERX requirement
    } else {
      setS8DrugAuthModalStatus(false); // ERX requirement
    }
  }, [isPoisonClassS8])

  return (
    <div className="container-fluid">
      {/* 
      <CustomModal
        className="modal-md text-center"
        openModal={s8DrugAuthModalStatus}
        title="S8 Drug Authentication"
        noFooterButtons={true}
        modalBodyContent={
          <ReAuthenticate
            stageChange="Stage-Change: S8-Drug-access"
            successfulCallback={() => {
              console.log("Authenticated successfully");
              setS8DrugAuthModalStatus(false);
            }}
          />
        }
      /> */}

      {loading && <Loader loading={loading} />}
      {/* {loading && (
        <div className="list-loader">
          <CircularProgress disableShrink className="primary-loader" />
        </div>
      )} */}
      <form className="row" onSubmit={formik.handleSubmit} autoComplete="off">
        <div className="col-sm-12 mt-n2">
          <Label
            className="gray ex-small"
            required={true}
            title="Drug Database"
          />
          <SearchInput
            id="drugdata"
            name="drugdata"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.drugdata}
            className={`w-100 font-14 ${isPoisonClassS8 && !props.hideS8 &&
            "prescription-strike"} ${isExtemporaneousDrug &&
            "prescription-strike"} ${blockedPBSType &&
            "prescription-strike"} ${specialDrugType === "S4_DISABLED" &&
            "prescription-strike"} ${isDiscontinuedDrug &&
            "prescription-strike"} ${isIsotretinoinDrugList &&
            "prescription-strike"} ${isInPersonGPDrugList &&
            "prescription-strike"} ${isOutOfStockDrug &&
            "prescription-strike"}`}
            // helperText={
            //   formik.touched.drugdata && formik.errors.drugdata
            //     ? formik.errors.drugdata
            //     : ""
            // }
            placeholder="Search Drug Database"
          />
          {formik.touched.drugdata && formik.errors.drugdata && (
            <Label
              className="small ml-1 prescription-error"
              title={formik.errors.drugdata}
            />
          )}
          {isPoisonClassS8 && !props.hideS8 && (
            <Label
              className="small ml-1 prescription-error"
              title="Schedule 8 Drug. Please empty the input and search another drug."
            />
          )}
          {specialDrugType === "S4_WARNING" && !blockedPBSType && (
            <Label
              className="small ml-1 prescription-error"
              title="Schedule 4D Drug. Caution when prescribing."
            />
          )}
          {specialDrugType === "S4_DISABLED" && (
            <Label
              className="small ml-1 prescription-error"
              title="Schedule 4D Drug (Special Policy). Please empty the input and search another drug."
            />
          )}
          {blockedPBSType && (
            <Label
              className="small ml-1 prescription-error"
              title={`Schedule ${blockedPBSType} Drug. Please empty the input and search another drug.`}
            />
          )}
          {isExtemporaneousDrug && (
            <Label
              className="small ml-1 prescription-error"
              title="Extemporaneous Drug. Please empty the input and search another drug."
            />
          )}
          {isDiscontinuedDrug && (
            <Label
              className="small ml-1 prescription-error"
              title="Product Discontinued. Please empty the input and search another drug (ie. Optisulin)."
            />
          )}
          {isIsotretinoinDrugList && (
            <Label
              className="small ml-1 prescription-error"
              title="Not to be prescribed by GP - refer to Dermatologist (Health Legislation). <br /> Please empty the input and search another drug."
            />
          )}
          {isInPersonGPDrugList && (
            <Label
              className="small ml-1 prescription-error"
              title="Not to be prescribed - refer to in-person GP (Health Legislation). <br /> Please empty the input and search another drug."
            />
          )}
          {
            isOutOfStockDrug && (
              <Label
                className="small ml-1 prescription-error"
                title={isOutOfStockDrug}
              />
            )
          }

          <div ref={drugListRef} style={{ position: "relative" }}>
            {!loading && isShowDrugList && drugList && (
              <DrugListDialog drugList={drugList} selectDrug={selectDrug} />
            )}
          </div>
        </div>
        {
          isDrugManuallyInput && (
            <div className="col-sm-12 custom-chk-lbl pl-4 mt-4">
              <span className="pr-4">
                <ICCheckbox
                  style={{ padding: 0, paddingRight: "5px" }}
                  name="S8 Drug"
                  onChange={(e) => {
                    setIsS8DrugManuallyTicked(e.target.checked);
                    if (e.target.checked) {
                      setS8DrugAuthModalStatus(true);
                    }
                  }}
                  value={isS8DrugManuallyTicked}
                  inputProps={{ "aria-label": "S8 Drug" }}
                  label="S8 Drug"
                />
              </span>
            </div>
          )
        }
        <div className="col-sm-12 custom-chk-lbl pl-4 mt-4">
          <span className="pr-4">
            <ICCheckbox
              style={{ padding: 0, paddingRight: "5px" }}
              name="PBS"
              disabled={isDrugPrefilled && !PBSPrefilled}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.PBS}
              inputProps={{ "aria-label": "PBS" }}
              label="PBS"
            />
          </span>
          <span className="pr-4">
            <ICCheckbox
              style={{ padding: 0, paddingRight: "5px" }}
              name="brandSubstitution"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.brandSubstitution}
              inputProps={{ "aria-label": "Brand Substitution Not Permitted" }}
              label="Brand Substitution Not Permitted"
            />
          </span>
          <span className="pr-4">
            <ICCheckbox
              style={{ padding: 0, paddingRight: "5px" }}
              name="isIncludeBrandName"
              disabled={disableIncBrandNameTic}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.isIncludeBrandName}
              inputProps={{
                "aria-label": "Include Brand Name on Prescription"
              }}
              label="Include Brand Name on Prescription"
            />
          </span>
        </div>
        {PBSCodeSelect.length <= 1 && (
          <div className="col-sm-6 mt-3 float-left">
            <Label
              className="gray ex-small"
              required={isDrugPrefilled && formik.values.PBS}
              title="PBS Code"
            />
            <ICInput
              id="pbsCode"
              name="pbsCode"
              disabled={isDrugPrefilled}
              className="placeholder-small  ic-input-dark-font"
              type="text"
              label=""
              placeholder="e.g. 2242B"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.pbsCode}
            />
            {/* {(formik.values.PBS && !formik.values.pbsCode)
              && (
                <Label
                  className="small ml-1 prescription-error"
                  title={"PBS Code is required"}
                />
              )} */}
          </div>
        )}
        {PBSCodeSelect.length > 1 && (
          <div className="col-sm-6 mt-3 float-left">
            <Label
              className="gray ex-small"
              required={true}
              title="Select PBS Code"
            />
            <ICInput
              id="pbsCode"
              name="pbsCode"
              className="placeholder-small ic-input-dark-font"
              type="text"
              label=""
              select
              required
              placeholder="e.g. 2242B"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.pbsCode}
            >
              {PBSCodeSelect.map(item => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </ICInput>
            {!formik.values.pbsCode && (
              <Label
                className="small ml-1 prescription-error"
                title={"PBS Code is required"}
              />
            )}
          </div>
        )}
        <div className="col-sm-6 mt-3 float-left">
          <Label
            className="gray ex-small"
            title="PBS Manufacturer Code"
            required={isDrugPrefilled && formik.values.PBS}
          />
          <ICInput
            id="pbsManuCode"
            name="pbsManuCode"
            disabled={isDrugPrefilled}
            className="placeholder-small ic-input-dark-font"
            type="text"
            label=""
            placeholder="e.g. AS"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.pbsManuCode}
          />
          {/* {(formik.values.PBS && !formik.values.pbsManuCode)
            && (
              <Label
                className="small ml-1 prescription-error"
                title={"PBS Manufacturer Code is required"}
              />
            )} */}
        </div>
        <div className="clearfix"></div>
        {restrictionList.length > 0 && (
          <div className="col-sm-12 mt-4 pl-2 custom-chk-lbl">
            <RestrictionListView restrictionList={restrictionList} />
          </div>
        )}
        <div className="col-sm-12 mt-4 pl-2 custom-chk-lbl">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px", paddingLeft: "15px" }}
            name="authorityRequiredPBS"
            disabled={isDrugPrefilled || !formik.values.PBS}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.authorityRequiredPBS}
            inputProps={{ "aria-label": "Authority Required PBS Prescription" }}
            label="Authority Required PBS Prescription"
          />
        </div>
        {authorityRequiredPBS && (
          <div className="col-sm-12">
            <Label
              className="prescription-text small font-medium font-12"
              title="Please complete if you are writing an Authority Required PBS Prescription"
            />
            <br />
            <Label
              className="text-center font-15 mt-2 mb-0 font-medium"
              title="PBS Authority Phone Number: 1800 888 333"
            />
            <br />
            <Label
              className="text-center font-15 mb-0 font-medium"
              title={"PBS Authority Prescription Number: " + PBSAuth}
            />
            <br />
            <Label
              className="text-center font-15 mb-0 font-medium"
              title={"Patient's Medicare Number: " + medicareNo}
            />
          </div>
        )}
        {isDrugPrefilled && authorityRequiredPBS && SACSelect.length === 0 && (
          <Fragment>
            {!APN && !isAPNRequired && (
              <div className="col-sm-12 mt-2 float-left">
                <Label
                  className="gray ex-small"
                  title="Streamlined Authority Code"
                  required={true}
                />
                <ICInput
                  id="SAC"
                  name="SAC"
                  disabled={!APN && !isAPNRequired}
                  type="text"
                  className="placeholder-small ic-input-dark-font"
                  label=""
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.SAC}
                  error={formik.touched.SAC && formik.errors.SAC ? true : false}
                  helperText={
                    formik.touched.SAC && formik.errors.SAC
                      ? formik.errors.SAC
                      : ""
                  }
                />
                {!formik.values.SAC && (
                  <Label
                    className="small ml-1 prescription-error"
                    title={"Streamlined Authority Code is required"}
                  />
                )}
              </div>
            )}
          </Fragment>
        )}
        {isDrugPrefilled &&
          authorityRequiredPBS &&
          SACSelect.length > 0 &&
          !APN &&
          !isAPNRequired && (
            <div className="col-sm-12 mt-2 float-left">
              <Label
                className="gray ex-small"
                title="Streamlined Authority Code"
                required={true}
              />
              <ICInput
                id="SAC"
                name="SAC"
                select
                type="text"
                className="placeholder-small ic-input-dark-font"
                label=""
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.SAC}
                error={!!formik.errors.SAC}
                helperText={formik.errors.SAC ? formik.errors.SAC : ""}
              >
                {SACSelect.map(item => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </ICInput>
              {/* {formik.errors.SAC && <div>{formik.errors.SAC}</div>} */}
              {!formik.values.SAC && (
                <Label
                  className="small ml-1 prescription-error"
                  title={"Streamlined Authority Code is required"}
                />
              )}
            </div>
          )}
        {isDrugPrefilled &&
          authorityRequiredPBS &&
          !SAC &&
          SACSelect.length === 0 && (
            <div className="col-sm-12 mt-2 float-left">
              <Label
                className="gray ex-small"
                title="Authority Approval Number"
                required={true}
              />
              <ICInput
                id="APN"
                name="APN"
                type="text"
                className="placeholder-small ic-input-dark-font"
                label=""
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.APN}
                error={formik.errors.APN ? true : false}
                helperText={formik.errors.APN ? formik.errors.APN : ""}
              />
              {!formik.values.APN && (
                <Label
                  className="small ml-1 prescription-error"
                  title={"Authority Approval Number is required"}
                />
              )}
            </div>
          )}
        {!isDrugPrefilled && authorityRequiredPBS && (
          <div className="col-sm-6 mt-2 float-left">
            <Label
              className="gray ex-small"
              title="Streamlined Authority Code"
            />
            <ICInput
              id="SAC"
              name="SAC"
              disabled={!!formik.values.APN}
              type="text"
              className="placeholder-small ic-input-dark-font"
              label=""
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.SAC}
              error={formik.errors.SAC ? true : false}
              helperText={formik.errors.SAC ? formik.errors.SAC : ""}
            />
            {!formik.values.SAC && !formik.values.APN && (
              <Label
                className="small ml-1 prescription-error"
                title={"One from these two fields is required"}
              />
            )}
          </div>
        )}
        {!isDrugPrefilled && authorityRequiredPBS && (
          <div className="col-sm-6 mt-2 float-left">
            <Label
              className="gray ex-small"
              title="Authority Approval Number"
            />
            <ICInput
              id="APN"
              name="APN"
              disabled={!!formik.values.SAC}
              type="text"
              className="placeholder-small ic-input-dark-font"
              label=""
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.APN}
              error={formik.errors.APN ? true : false}
              helperText={formik.errors.APN ? formik.errors.APN : ""}
            />
            {!formik.values.SAC && !formik.values.APN && (
              <Label
                className="small ml-1 prescription-error"
                title={"One from these two fields is required"}
              />
            )}
          </div>
        )}
        <div className="clearfix"></div>

        {!isDrugManuallyInput && (
          <div className="col-sm-12 mt-3">
            <Label
              className="gray ex-small"
              required={true}
              title="Drug Name"
            />
            <ICInput
              id="drugName"
              name="drugName"
              disabled={isDrugPrefilled || !isDrugManuallyInput}
              type="text"
              className="placeholder-small w-100 ic-input-dark-font"
              label=""
              placeholder="e.g. Aropax (Paroxetine Hydrochloride)"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.drugName}
              error={
                formik.touched.drugName && formik.errors.drugName ? true : false
              }
              helperText={
                formik.touched.drugName && formik.errors.drugName
                  ? formik.errors.drugName
                  : ""
              }
            />
            {isDrugManuallyInput && !formik.values.drugName && (
              <Label
                className="small ml-1 prescription-error"
                title={"Drug name is required"}
              />
            )}
          </div>
        )}

        {isDrugManuallyInput && (
          <div className="col-sm-6 mt-3 float-left">
            <Label
              className="gray ex-small"
              // required={true}
              title="Brand Name"
            />
            <ICInput
              id="manualInputBrandName"
              name="manualInputBrandName"
              disabled={isDrugPrefilled}
              type="text"
              className="placeholder-small ic-input-dark-font"
              label=""
              placeholder="e.g. Aropax"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.manualInputBrandName}
              error={
                formik.touched.manualInputBrandName &&
                formik.errors.manualInputBrandName
                  ? true
                  : false
              }
              helperText={
                formik.touched.manualInputBrandName &&
                formik.errors.manualInputBrandName
                  ? formik.errors.manualInputBrandName
                  : ""
              }
            />
            {/* {!formik.values.manualInputBrandName && (
              <Label
                className="small ml-1 prescription-error"
                title={"This field is required"}
              />
            )} */}
          </div>
        )}

        {isDrugManuallyInput && (
          <div className="col-sm-6 mt-3 float-left">
            <Label
              className="gray ex-small"
              required={true}
              title="Generic Name"
            />
            <ICInput
              id="manualInputGenericName"
              name="manualInputGenericName"
              disabled={isDrugPrefilled}
              type="text"
              className="placeholder-small ic-input-dark-font"
              label=""
              placeholder="e.g. Paroxetine Hydrochloride"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.manualInputGenericName}
              error={
                formik.touched.manualInputGenericName &&
                formik.errors.manualInputGenericName
                  ? true
                  : false
              }
              helperText={
                formik.touched.manualInputGenericName &&
                formik.errors.manualInputGenericName
                  ? formik.errors.manualInputGenericName
                  : ""
              }
            />
            {!formik.values.manualInputGenericName && (
              <Label
                className="small ml-1 prescription-error"
                title={"This field is required"}
              />
            )}
          </div>
        )}

        {/* {
          packageSizeOptions.length > 1 && (
            <div className="col-sm-12 mt-2 mb-2">
              <div className="col-sm-12 mt-3">
                <Label className="gray ex-small" title="Select Package Size" />
                <ICSelect
                  value={formik.values.packageSize}
                  placeholder={formik.values.packageSize}
                  className="placeholder-small"
                  items={packageSizeOptions}
                  useId="_id"
                  useValue="val"
                  handleChange={val => {
                    // formik.setFieldValue("packageSize", val);
                    console.log("Package size selected: ", val);
                    fillOptionalePresParameters(drugDetails, val);
                  }}
                  error={
                    formik.touched.packageSize && formik.errors.packageSize
                      ? formik.errors.packageSize
                      : ""
                  }
                />
              </div>
            </div>
          )
        } */}


        {/* <div className="col-sm-12 p-0 m-0 ml-3">
          <Label
            className="font-15 bold-font"
            title={formik.values.brandName}
          />
        </div> */}

        <div className={isDrugManuallyInput ? "col-sm-6 mt-3 float-left" : "col-sm-6 mt-3 float-left d-none"}>
          <Label className="gray ex-small" required={true} title="Strength" />
          <ICInput
            id="strength"
            name="strength"
            disabled={isDrugPrefilled || !isDrugManuallyInput}
            type="text"
            className="placeholder-small ic-input-dark-font"
            label=""
            placeholder="e.g. 20mg"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.strength}
            error={
              formik.touched.strength && formik.errors.strength ? true : false
            }
            helperText={
              formik.touched.strength && formik.errors.strength
                ? formik.errors.strength
                : ""
            }
          />
          {isDrugManuallyInput && !formik.values.strength && (
            <Label
              className="small ml-1 prescription-error"
              title={"This field is required"}
            />
          )}
        </div>

        {
          isDrugManuallyInput && (
            <div className="col-sm-6 mt-3 float-left">
              <Label className="gray ex-small" required={true} title="Form Type" />
              <ICInput
                id="formType"
                name="formType"
                disabled={isDrugPrefilled || !isDrugManuallyInput}
                type="text"
                className="placeholder-small ic-input-dark-font"
                label=""
                placeholder="e.g. Tablets"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.formType}
                error={
                  formik.touched.formType && formik.errors.formType ? true : false
                }
                helperText={
                  formik.touched.formType && formik.errors.formType
                    ? formik.errors.formType
                    : ""
                }
              />
              {isDrugManuallyInput && !formik.values.formType && (
                <Label
                  className="small ml-1 prescription-error"
                  title={"This field is required"}
                />
              )}
            </div>
          )
        }


        <div className="clearfix"></div>

        <div className="col-sm-6 mt-2 float-left">
          <Label
            className="gray ex-small"
            required={true}
            title="Dosing Amount "
          />

          <ICInput
            id="dose"
            name="dose"
            type="text"
            className="placeholder-small ic-input-dark-font"
            label=""
            placeholder="e.g. 20mg"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.dose}
            error={
              (isDrugPrefilled || formik.touched.dose) && formik.errors.dose
                ? true
                : false
            }
            helperText={
              (isDrugPrefilled || formik.touched.dose) && formik.errors.dose
                ? formik.errors.dose
                : ""
            }
          />
          {(isDrugManuallyInput || formik.values.strength) &&
            !formik.values.dose && (
              <Label
                className="small ml-1 prescription-error"
                title={"This field is required"}
              />
            )}
        </div>

        <div className="col-sm-6 mt-2 float-left">
          <Label className="gray ex-small" required={true} title="Frequency" />
          <ICInput
            id="frequency"
            name="frequency"
            type="text"
            className="placeholder-small ic-input-dark-font"
            label=""
            placeholder="e.g. 2 Daily"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.frequency}
            error={
              (isDrugPrefilled || formik.touched.frequency) &&
              formik.errors.frequency
                ? true
                : false
            }
            helperText={
              (isDrugPrefilled || formik.touched.frequency) &&
              formik.errors.frequency
                ? formik.errors.frequency
                : ""
            }
          />
          {(isDrugManuallyInput || formik.values.strength) &&
            !formik.values.frequency && (
              <Label
                className="small ml-1 prescription-error"
                title={"This field is required"}
              />
            )}
        </div>

        <div className="clearfix"></div>

        {isDrugManuallyInput && (
          <div className="col-sm-6 mt-3 float-left">
            <Label className="gray ex-small" required={true} title="Route" />
            <ICInput
              id="manualInputRoute"
              name="manualInputRoute"
              disabled={isDrugPrefilled}
              type="text"
              className="placeholder-small ic-input-dark-font"
              label=""
              placeholder="e.g. Oral, Topical, etc."
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.manualInputRoute}
              error={
                formik.touched.manualInputRoute &&
                formik.errors.manualInputRoute
                  ? true
                  : false
              }
              helperText={
                formik.touched.manualInputRoute &&
                formik.errors.manualInputRoute
                  ? formik.errors.manualInputRoute
                  : ""
              }
            />
            {!formik.values.manualInputRoute && (
              <Label
                className="small ml-1 prescription-error"
                title={"This field is required"}
              />
            )}
          </div>
        )}

        <div className="col-sm-12 custom-chk-lbl pl-4 mt-4">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="withFood"
            id="withFood"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.withFood}
            inputProps={{ "aria-label": "with food" }}
            label="with food"
          />
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px", paddingLeft: "15px" }}
            name="emptyStomach"
            id="emptyStomach"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.emptyStomach}
            inputProps={{ "aria-label": "on an empty stomach" }}
            label="on an empty stomach"
          />
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px", paddingLeft: "15px" }}
            name="isUnusualDose"
            id="isUnusualDose"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.isUnusualDose}
            inputProps={{ "aria-label": "flag as unusual dose" }}
            label="flag as unusual dose"
          />
        </div>
        {(!isDrugPrefilled ||
          isManuallyEnterQty ||
          medQuantitySelectWithManualInput.length === 0) && (
          <div className="col-sm-6 mt-2 float-left">
            <Label
              className="gray ex-small"
              required={true}
              title="Quantity of the Medication"
            />

            <ICInput
              id="medQuantity"
              name="medQuantity"
              type="number"
              className="placeholder-small ic-input-dark-font"
              label=""
              placeholder="e.g. 30"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.medQuantity}
              error={formik.errors.medQuantity ? true : false}
              helperText={
                formik.errors.medQuantity ? formik.errors.medQuantity : ""
              }
            />
          </div>
        )}
        {isDrugPrefilled &&
          !isManuallyEnterQty &&
          medQuantitySelectWithManualInput.length > 0 && (
            <div className="col-sm-6 mt-2 float-left">
              <Label
                className="gray ex-small"
                required={true}
                title="Select Quantity of the Medication"
              />

              <ICInput
                id="medQuantity"
                name="medQuantity"
                select
                type="text"
                label=""
                className="placeholder-small ic-input ic-input-dark-font"
                placeholder="e.g. 30"
                autoComplete="off"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.medQuantity}
                error={
                  formik.touched.medQuantity && formik.errors.medQuantity
                    ? true
                    : false
                }
                helperText={
                  formik.touched.medQuantity && formik.errors.medQuantity
                    ? formik.errors.medQuantity
                    : ""
                }
              >
                {medQuantitySelectWithManualInput.map(item => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </ICInput>
            </div>
          )}
        <div className="col-sm-6 mt-2 float-left">
          <Label
            className="gray ex-small"
            required={true}
            title="Number of Repeats"
          />

          <ICInput
            id="numberOfRepeat"
            name="numberOfRepeat"
            type="number"
            className="placeholder-small ic-input-dark-font"
            inputProps={{ max: maxNumberOfRepeats, min: 0 }}
            label=""
            placeholder="e.g. 0"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.numberOfRepeat}
            error={
              formik.errors.numberOfRepeat ||
              formik.values.numberOfRepeat > maxNumberOfRepeats
                ? true
                : false
            }
            helperText={
              formik.errors.numberOfRepeat
                ? formik.errors.numberOfRepeat
                : formik.values.numberOfRepeat > maxNumberOfRepeats
                  ? "Maximum Number of Repeats Exceeded"
                  : ""
            }
          />

        </div>
        <div className="clearfix"></div>

        {
          props.hideS8 && (
            <Fragment>
              {/* We have another condition for minIntervalRepears for ERX. You can ignore this bottom code for miniIntervalRepeats */}
              {/* <div className="col-sm-6 mt-2 float-left">
                <Label
                  className="gray ex-small"
                  required={props.hideS8}
                  title="Interval Between Repeats (Days)"
                />

                <ICInput
                  id="miniIntervalRepeats"
                  name="miniIntervalRepeats"
                  type="number"
                  className="placeholder-small ic-input-dark-font"
                  label=""
                  placeholder="e.g. 30"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.miniIntervalRepeats}
                  error={formik.errors.miniIntervalRepeats ? true : false}
                  helperText={
                    formik.errors.miniIntervalRepeats ? formik.errors.miniIntervalRepeats : ""
                  }
                />
              </div> */}

              <div className="col-sm-6 mt-2 float-left">
                {/* <Label
                  className="gray ex-small"
                  required={props.hideS8}
                  title="Category"
                />


                <ICInput
                  id="category"
                  name="category"
                  type="text"
                  className="placeholder-small ic-input-dark-font"
                  label=""
                  placeholder=""
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.category}
                  error={formik.errors.category ? true : false}
                  helperText={
                    formik.errors.category ? formik.errors.category : ""
                  }
                /> */}
                <Label className="gray ex-small" title="Category" required={props.hideS8} />
                <ICSelect
                  label=""
                  placeholder="Select Category"
                  id="category"
                  name="category"
                  items={CATEGORY_FOR_MEDICINAL_CANNABIS}
                  useId="_id"
                  useValue="value"
                  value={formik.values.category}
                  onBlur={formik.handleBlur}
                  handleChange={val => {
                    formik.values.category = val;
                    console.log("Value changed: ", val);
                    formik.setFieldValue("category", val ? val : "");
                    formik.handleChange("category");
                  }}
                  error={formik.touched.category && formik.errors.category ? true : false}
                  helperText={
                    formik.touched.category && formik.errors.category
                      ? formik.errors.category
                      : ""
                  }
                />
                {formik.errors.category && formik.touched.category ? (
                  <Label title="Please select category" className="small error" />
                ) : (
                  ""
                )}
              </div>
            </Fragment>
          )
        }

        <div className="clearfix"></div>
        <div className="col-sm-6 custom-chk-lbl pl-4 mt-4">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="regulation24"
            id="regulation24"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.regulation24}
            inputProps={{ "aria-label": "Regulation 24" }}
            label="Regulation 24"
          />
        </div>

        {/* ERX Requirement */}
        {/* <div className="col-sm-12 custom-chk-lbl pl-4 mt-4">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="isNotToMySL"
            id="isNotToMySL"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.isNotToMySL}
            inputProps={{ "aria-label": "Do not upload to patient's MySL" }}
            label="Do not upload to patient's MySL"
          />
        </div>

        <div className="col-sm-12 custom-chk-lbl pl-4 mt-4">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="isSendToPharmacy"
            id="isSendToPharmacy"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.isSendToPharmacy}
            inputProps={{ "aria-label": "Do not upload to patient's MySL" }}
            label="Send To Pharmacy (No Token or MySL)"
          />
        </div>

        {
          formik.values.isSendToPharmacy && (
            <div className="col-sm-12 pl-4 mt-3">
              <Label className="gray ex-small" title="Options for Send to Pharmacy" />
              <ICSelect
                value={formik.values.sendToPharmacyValue}
                placeholder={formik.values.sendToPharmacyValue}
                className="placeholder-small"
                items={sendToPharmacyTagOptions}
                handleChange={val => {
                  formik.setFieldValue("sendToPharmacyValue", val);
                }}
                error={
                  formik.touched.sendToPharmacyValue && formik.errors.sendToPharmacyValue
                    ? formik.errors.sendToPharmacyValue
                    : ""
                }
              />
            </div>
          )
        } */}

        <div className="clearfix"></div>
        {/* ERX Requirement */}
        {/* <div className="col-sm-6 custom-chk-lbl pl-4 mt-4">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="scriptOwing"
            id="scriptOwing"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.scriptOwing}
            inputProps={{ "aria-label": "Script Owing" }}
            label="Script Owing"
          />
        </div> */}

        {/* ERX Requirement */}
        {
          (showMinRepeatInterval || isS8DrugManuallyTicked || props.assessmentData.assessmentType === "Medicinal Cannabis") && formik.values.numberOfRepeat > 0 ? (
            <>
              <div className="col-sm-6 mt-2 float-left">
                <Label
                  className="gray ex-small"
                  required={formik.values.numberOfRepeat >= 0}
                  title="Minimum Interval Between Repeats (Days)"
                />

                <ICInput
                  id="miniIntervalRepeats"
                  name="miniIntervalRepeats"
                  type="number"
                  className="placeholder-small ic-input-dark-font red-helper-text"
                  inputProps={{ min: 0 }}
                  label=""
                  placeholder="e.g. 0"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.miniIntervalRepeats}
                  error={
                    formik.errors.miniIntervalRepeats
                      ? true
                      : false
                  }
                  helperText={
                    formik.errors.miniIntervalRepeats
                      ? formik.errors.miniIntervalRepeats
                      : ""
                  }
                />
              </div>
            </>
          ) : ('')
        }


        {/*
        <div className="col-sm-6 pl-2 mt-4">
          <Label className="gray ex-small" title="Indication" required={props.hideS8} />
          <ICSelect
            label=""
            placeholder="Select Indication"
            id="indication"
            name="indication"
            items={MEDICINAL_CANNABIS_INDICATIONS}
            useId="_id"
            useValue="value"
            value={formik.values.indication}
            onBlur={formik.handleBlur}
            handleChange={val => {
              formik.values.indication = val;
              console.log("Value changed: ", val);
              formik.setFieldValue("indication", val ? val : '');
              formik.handleChange("indication");
            }}
            error={formik.touched.indication && formik.errors.indication ? true : false}
            helperText={
              formik.touched.indication && formik.errors.indication
                ? formik.errors.indication
                : ""
            }
          />
          {formik.errors.indication && formik.touched.indication ? (
            <Label title="Please select indication" className="small error" />
          ) : (
            ""
          )}
        </div>
     */}
        {/*
        <div className="col-sm-12 custom-chk-lbl pl-4 mt-4">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="isNotToMySL"
            id="isNotToMySL"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.isNotToMySL}
            inputProps={{ "aria-label": "Do not upload to patient's MySL" }}
            label="Do not upload to patient's MySL"
          />
        </div>

        <div className="clearfix"></div>
         */}
        {/* 
        <div className="col-sm-6 custom-chk-lbl pl-4 mt-4">
          <ICCheckbox
            style={{ padding: 0, paddingRight: "5px" }}
            name="scriptOwing"
            id="scriptOwing"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.scriptOwing}
            inputProps={{ "aria-label": "Script Owing" }}
            label="Script Owing"
          />
        </div>
 */}
        <div className="clearfix"></div>
        {/* 
        {isPoisonClassS4 && (
          <div className="col-sm-6 mt-2 float-left">
            <Label
              className="gray ex-small"
              required={true}
              title="Minimum Interval Between Repeats (Days)"
            />

            <ICInput
              id="miniIntervalRepeats"
              name="miniIntervalRepeats"
              type="number"
              className="placeholder-small ic-input-dark-font"
              label=""
              placeholder="e.g. 5"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.miniIntervalRepeats}
              error={
                (isDrugPrefilled || formik.touched.miniIntervalRepeats) &&
                formik.errors.miniIntervalRepeats
                  ? true
                  : false
              }
              helperText={
                (isDrugPrefilled || formik.touched.miniIntervalRepeats) &&
                formik.errors.miniIntervalRepeats
                  ? formik.errors.miniIntervalRepeats
                  : ""
              }
            />
            {!formik.values.miniIntervalRepeats && (
              <Label
                className="small ml-1 prescription-error"
                title={"This field is required"}
              />
            )}
          </div>
        )}
 */}
        <div className="clearfix"></div>
        {/* 
        <div className="col-sm-12 mt-4">
          <Label className="gray ex-small" title="Reason for Prescribe" />
          <ICInput
            id="reasonForPrescribe"
            name="reasonForPrescribe"
            className="text-area"
            label=""
            multiline
            rows="2"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.reasonForPrescribe}
            error={
              formik.touched.reasonForPrescribe &&
              formik.errors.reasonForPrescribe
                ? true
                : false
            }
            helperText={
              formik.touched.reasonForPrescribe &&
              formik.errors.reasonForPrescribe
                ? formik.errors.reasonForPrescribe
                : ""
            }
          />
        </div>
 */}

        {/* <div className="col-sm-12 mt-4">
          <Label className="gray ex-small" title="Annotation Text" />
          <ICSelect
            value={formik.values.annotationTextFromDoctor}
            className="placeholder-small"
            placeholder="Select Text"
            items={annotationTextOptions}
            handleChange={val => {
              formik.setFieldValue("annotationTextFromDoctor", val);
            }}
            error={
              formik.touched.annotationTextFromDoctor && formik.errors.annotationTextFromDoctor
                ? formik.errors.annotationTextFromDoctor
                : ""
            }
          />
        </div> */}

        {/* ERX Requirement about Name of Pharmacy */}

        {/* <div className="col-sm-12 mt-4">
          <Label className="gray ex-small" title="Name of the pharmacy (if required by NSW Health)" />
          <ICInput
            id="PrescribedItem_Reserved_04"
            name="PrescribedItem_Reserved_04"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.PrescribedItem_Reserved_04}
            error={
              formik.touched.PrescribedItem_Reserved_04 &&
                formik.errors.PrescribedItem_Reserved_04
                ? true
                : false
            }
            helperText={
              formik.touched.PrescribedItem_Reserved_04 &&
                formik.errors.PrescribedItem_Reserved_04
                ? formik.errors.PrescribedItem_Reserved_04
                : ""
            }
          />
        </div> */}

        {/* <div className="col-sm-12 mt-4">
          <Label className="gray ex-small" title={controlledSubstanceReferenceFieldLabel} />
          <ICInput
            id="controlledSubstanceReference"
            name="controlledSubstanceReference"
            label=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.controlledSubstanceReference}
            error={
              formik.touched.controlledSubstanceReference &&
                formik.errors.controlledSubstanceReference
                ? true
                : false
            }
            helperText={
              formik.touched.controlledSubstanceReference &&
                formik.errors.controlledSubstanceReference
                ? formik.errors.controlledSubstanceReference
                : ""
            }
          />
        </div> */}

        <div className="col-sm-12 mt-4">
          <Label
            className="gray ex-small"
            title="Other Prescription Details ONLY"
          />

          {/* <Input
            type="textarea"
            name="text"
            id="exampleText"
            className="text-area"
          /> */}
          <ICInput
            id="otherPrescriptionDetails"
            name="otherPrescriptionDetails"
            className="text-area"
            label=""
            multiline
            rows="6"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.otherPrescriptionDetails}
            error={
              formik.touched.otherPrescriptionDetails &&
              formik.errors.otherPrescriptionDetails
                ? true
                : false
            }
            helperText={
              formik.touched.otherPrescriptionDetails &&
              formik.errors.otherPrescriptionDetails
                ? formik.errors.otherPrescriptionDetails
                : ""
            }
          />
        </div>
        <div className="col-sm-12 text-center mt-5 ">
          <Button
            clickEvent={previewDoc}
            type="button"
            title="Preview"
            className="gray-outline"
            disabled={buttonDisabled}
          />
          <Button type="submit" className="ml-3" disabled={buttonDisabled} />
        </div>
      </form>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  setIsPBSAuthorityRequired: data => dispatch(setIsPBSAuthorityRequired(data)),
  updateEbsNumber: data => dispatch(updateEbsNumber(data)),
});

const mapStateToProps = props => ({
  auth: props.auth.user
});

export default connect(mapStateToProps, mapDispatchToProps)(PrescriptionForm);

PrescriptionForm.defaultProps = {
  hideS8: false,
  data: null,
  serverConstants: null,
  onSaveSubmit: () => {
  },
  onPreviewSubmit: () => {
  }
};

PrescriptionForm.propTypes = {
  onSaveSubmit: PropTypes.func,
  onPreviewSubmit: PropTypes.func,
  hideS8: PropTypes.bool,
  data: PropTypes.object,
  serverConstants: PropTypes.object
};
